/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
export type Byte = { data: number[]; type: 'Buffer' }
export type JSONPrimitive = string | number | boolean | null
export type JSONValue = JSONPrimitive | JSONObject | JSONArray
export type JSONArray = JSONValue[]
export type JSONObject = { [member: string]: JSONValue }
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigInt: { input: number; output: number }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: Byte; output: Byte }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: Date }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: JSONValue; output: JSONValue }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: JSONObject; output: JSONObject }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any }
  Void: { input: null; output: null }
  _Any: { input: any; output: any }
  federation__FieldSet: { input: any; output: any }
  link__Import: { input: any; output: any }
}

export type AbTest = {
  __typename?: 'ABTest'
  assignedVariant?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  variants: Array<AbTestVariant>
}

export type AbTestInput = {
  assignedVariant?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type AbTestVariant = {
  __typename?: 'ABTestVariant'
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export enum AcceptSource {
  App = 'APP',
  Verbal = 'VERBAL',
  Web = 'WEB',
}

export enum AccessLevel {
  CareCoordinator = 'CARE_COORDINATOR',
  Coach = 'COACH',
  CommunityFacilitator = 'COMMUNITY_FACILITATOR',
  Manager = 'MANAGER',
}

export type AccountsFilter = {
  onlyShowInOnboarding?: InputMaybe<Scalars['Boolean']['input']>
}

export type ActiveState = {
  __typename?: 'ActiveState'
  title: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type AddTagToPatientAction = {
  __typename?: 'AddTagToPatientAction'
  tagID: Scalars['ID']['output']
  uid: Scalars['ID']['output']
}

export type AdditionalSignupQuestion = AdditionalSignupQuestionSimple

export type AdditionalSignupQuestionSimple = {
  __typename?: 'AdditionalSignupQuestionSimple'
  annotation?: Maybe<Scalars['String']['output']>
  label: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type AdvancedChat = {
  __typename?: 'AdvancedChat'
  chatID: Scalars['ID']['output']
  role: Scalars['String']['output']
  unseenMessagesCount: Scalars['Int']['output']
}

export type AfterAppLoadGetStartedScreen = {
  __typename?: 'AfterAppLoadGetStartedScreen'
  success?: Maybe<Scalars['Boolean']['output']>
}

export type AfterAppLoadScreen = AfterAppLoadGetStartedScreen | AfterAppLoadSignupFormScreen

export type AfterAppLoadSignupFormScreen = {
  __typename?: 'AfterAppLoadSignupFormScreen'
  form: SignupForm
}

export type AllPaymentsCompleted = {
  __typename?: 'AllPaymentsCompleted'
  badgeCopy?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  iconName?: Maybe<Scalars['String']['output']>
}

export type AnswerInAppRatingResult = {
  __typename?: 'AnswerInAppRatingResult'
  rating: InAppRating
}

export type AperoInvoice = {
  __typename?: 'AperoInvoice'
  amountCharged: Scalars['String']['output']
  dueDate: Scalars['Date']['output']
  id: Scalars['String']['output']
}

export type AperoPaymentInformation = {
  __typename?: 'AperoPaymentInformation'
  id?: Maybe<Scalars['String']['output']>
  invoices?: Maybe<Array<AperoInvoice>>
}

export enum AppActivityLevel {
  /** No app activity for 14 or more days. */
  Dormant = 'DORMANT',
  /**
   * Opened the app within the last 3 days, but has not completed a practice for 3 or more days.
   * Stays ENGAGED indefinitely while the participant keeps opening the app.
   */
  Engaged = 'ENGAGED',
  /** No app activity for 3 or more days. */
  Inactive = 'INACTIVE',
}

export type AppStoreReviewPromptStatus = {
  __typename?: 'AppStoreReviewPromptStatus'
  shouldPromptReview: Scalars['Boolean']['output']
}

export enum AppUpdateStatus {
  UpdateRecommended = 'UPDATE_RECOMMENDED',
  UpdateRequired = 'UPDATE_REQUIRED',
  UpToDate = 'UP_TO_DATE',
}

export type AppUsageSessionInput = {
  clientSessionId: Scalars['String']['input']
  deviceId: Scalars['String']['input']
  endedAt: Scalars['DateTime']['input']
  startedAt: Scalars['DateTime']['input']
  timezone: Scalars['String']['input']
}

export type AssessmentGraph = {
  __typename?: 'AssessmentGraph'
  /**
   * Score movement between the two most recent readings, matching the trend
   * bucket the motivational message was picked from. STABLE when the two most
   * recent scores are equal or a series has fewer than two points.
   */
  anxietyTrend: AssessmentTrend
  currentModule?: Maybe<Scalars['Int']['output']>
  depressionTrend: AssessmentTrend
  dueCheckInLessonID?: Maybe<Scalars['ID']['output']>
  motivationalMessage: Scalars['String']['output']
  motivationalMessageVariantID: Scalars['String']['output']
  series: Array<AssessmentGraphSeries>
  totalModules: Scalars['Int']['output']
}

export type AssessmentGraphPoint = {
  __typename?: 'AssessmentGraphPoint'
  module: Scalars['Int']['output']
  score: Scalars['Int']['output']
}

export type AssessmentGraphSeries = {
  measure: AssessmentMeasure
  points: Array<AssessmentGraphPoint>
}

export enum AssessmentMeasure {
  Gad7 = 'GAD7',
  Phq9 = 'PHQ9',
}

export enum AssessmentTrend {
  Decreased = 'DECREASED',
  Increased = 'INCREASED',
  Stable = 'STABLE',
}

export enum AssignableQuestionnaire {
  Asrm = 'ASRM',
  Isi = 'ISI',
  Ocir = 'OCIR',
  Pcl5 = 'PCL5',
}

export type AutoOpeningLesson = {
  __typename?: 'AutoOpeningLesson'
  lessonID?: Maybe<Scalars['ID']['output']>
  responseIDToResume?: Maybe<Scalars['ID']['output']>
}

export type AvailableVideoCallSlot = {
  __typename?: 'AvailableVideoCallSlot'
  availabilityCalendarEventID: Scalars['String']['output']
  coach: CoachProfile
  coachInfoModalEnabled?: Maybe<Scalars['Boolean']['output']>
  coachInfoModalTitle?: Maybe<Scalars['String']['output']>
  end: Scalars['DateTime']['output']
  start: Scalars['DateTime']['output']
}

export type AvailableVideoCallSlots = {
  __typename?: 'AvailableVideoCallSlots'
  callType?: Maybe<VideoCallType>
  slots: Array<AvailableVideoCallSlot>
}

export type AvailableVideoCallSlotsResult = AvailableVideoCallSlots | VideoCall

export type BillingContact = {
  __typename?: 'BillingContact'
  billingID: Scalars['String']['output']
  birthDate?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  employer?: Maybe<Scalars['String']['output']>
  firstname: Scalars['String']['output']
  insuranceSubscriber: BillingContactInsuranceSubscriber
  lastname: Scalars['String']['output']
  source?: Maybe<Scalars['String']['output']>
}

export type BillingContactInsuranceSubscriber = {
  __typename?: 'BillingContactInsuranceSubscriber'
  birthDate?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  memberID?: Maybe<Scalars['String']['output']>
}

export type CancelPlanForm = CancelPlanScreenReasonsToCancel | CancelPlanScreenUserFeedback

export type CancelPlanResult = {
  __typename?: 'CancelPlanResult'
  success: Scalars['Boolean']['output']
}

export type CancelPlanScreenReasonsToCancel = {
  __typename?: 'CancelPlanScreenReasonsToCancel'
  items?: Maybe<Array<CancelPlanScreenReasonsToCancelItem>>
  label?: Maybe<Scalars['String']['output']>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type CancelPlanScreenReasonsToCancelItem = {
  __typename?: 'CancelPlanScreenReasonsToCancelItem'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CancelPlanScreenUserFeedback = {
  __typename?: 'CancelPlanScreenUserFeedback'
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type CancelVideoCallByParticipantResult = InAppVideoCallResult

export enum CancellationReasons {
  LifeEvent = 'LIFE_EVENT',
  MetGoalAndFeelBetter = 'MET_GOAL_AND_FEEL_BETTER',
  NotMatchWithTherapist = 'NOT_MATCH_WITH_THERAPIST',
  OtherReason = 'OTHER_REASON',
  ProgramNotWorthTheCost = 'PROGRAM_NOT_WORTH_THE_COST',
  SeekingOtherSupport = 'SEEKING_OTHER_SUPPORT',
  TooExpensive = 'TOO_EXPENSIVE',
}

export type CareTeamMember = {
  __typename?: 'CareTeamMember'
  coachID: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
}

export type ChatMessage = {
  __typename?: 'ChatMessage'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  direction: ChatMessageDirection
  feedID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  linkedLesson?: Maybe<ChatMessageLinkedLesson>
  linkedResponse?: Maybe<PatientResponse>
  linksToResponseID?: Maybe<Scalars['ID']['output']>
  messageID: Scalars['ID']['output']
  text: Scalars['String']['output']
}

export type ChatMessageCreated = {
  __typename?: 'ChatMessageCreated'
  chatMessage?: Maybe<ChatMessage>
}

export enum ChatMessageDirection {
  ToCoach = 'TO_COACH',
  ToPatient = 'TO_PATIENT',
}

export type ChatMessageEdited = {
  __typename?: 'ChatMessageEdited'
  chatMessage: ChatMessage
}

export enum ChatMessageLinkType {
  Lesson = 'LESSON',
  Response = 'RESPONSE',
}

export type ChatMessageLinkedLesson = {
  __typename?: 'ChatMessageLinkedLesson'
  category?: Maybe<Scalars['String']['output']>
  lessonID: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ChatMessageLinksToInput = {
  id: Scalars['ID']['input']
  type: ChatMessageLinkType
}

export type ChatMessagesResult = {
  __typename?: 'ChatMessagesResult'
  chatMessages: Array<ChatMessage>
}

export type CheckAppVersionResult = {
  __typename?: 'CheckAppVersionResult'
  description?: Maybe<Scalars['String']['output']>
  linkLabel?: Maybe<Scalars['String']['output']>
  linkToUpdate?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updateStatus: AppUpdateStatus
}

export enum ClientOs {
  Android = 'ANDROID',
  Ios = 'IOS',
}

export type CoachAvailability = {
  __typename?: 'CoachAvailability'
  coachProfiles?: Maybe<Array<CoachProfile>>
  videoCallSlots?: Maybe<Array<VideoCallSlot>>
}

export type CoachAvailabilityResult = CoachAvailability | VideoCall

export type CoachAvailabilityVideoCallSlotsByParticipant = {
  __typename?: 'CoachAvailabilityVideoCallSlotsByParticipant'
  coachProfiles?: Maybe<Array<CoachProfile>>
  videoCallSlots?: Maybe<Array<VideoCallSlot>>
}

export type CoachProfile = {
  __typename?: 'CoachProfile'
  description?: Maybe<Scalars['String']['output']>
  descriptionSpanish?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  firstname?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastname?: Maybe<Scalars['String']['output']>
  optInSpanish?: Maybe<Scalars['Boolean']['output']>
  photoUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  titleSpanish?: Maybe<Scalars['String']['output']>
  videoUrl?: Maybe<Scalars['String']['output']>
  videoUrlSD?: Maybe<Scalars['String']['output']>
  videoUrlSDSpanish?: Maybe<Scalars['String']['output']>
  videoUrlSpanish?: Maybe<Scalars['String']['output']>
}

export type CommonPatientHistory = PatientHistory & {
  __typename?: 'CommonPatientHistory'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  date?: Maybe<Scalars['String']['output']>
  entryID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<PatientHistoryType>
  value?: Maybe<Scalars['JSONObject']['output']>
}

/** The community type */
export type Community = {
  __typename?: 'Community'
  communityID: Scalars['ID']['output']
  createdAt: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  opensAt: Scalars['DateTime']['output']
}

export type CommunityFacilitator = {
  __typename?: 'CommunityFacilitator'
  name: Scalars['String']['output']
}

/** Post to the community */
export type CommunityPost = {
  community: Community
  communityID: Scalars['ID']['output']
  communityPostReplies: CommunityPostReplies
  content?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  label: Scalars['String']['output']
  postID: Scalars['ID']['output']
  publishedAt: Scalars['DateTime']['output']
  title: Scalars['String']['output']
}

/** Post to the community */
export type CommunityPostCommunityPostRepliesArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>
}

/** Community post was created */
export type CommunityPostCreated = {
  __typename?: 'CommunityPostCreated'
  communityPost: CommunityPost
}

/** Input specific for type of community post */
export type CommunityPostInput = {
  question?: InputMaybe<CommunityPostQuestionInput>
}

/** Question type post to the community */
export type CommunityPostQuestion = CommunityPost & {
  __typename?: 'CommunityPostQuestion'
  community: Community
  communityID: Scalars['ID']['output']
  communityPostReplies: CommunityPostReplies
  content?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  label: Scalars['String']['output']
  postID: Scalars['ID']['output']
  publishedAt: Scalars['DateTime']['output']
  title: Scalars['String']['output']
}

/** Question type post to the community */
export type CommunityPostQuestionCommunityPostRepliesArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>
}

/** Question type post contents */
export type CommunityPostQuestionInput = {
  content?: InputMaybe<Scalars['String']['input']>
}

/** Collection of community post replies with related metadata */
export type CommunityPostReplies = {
  __typename?: 'CommunityPostReplies'
  canReplyToPost: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  numberOfPatientsReplied: Scalars['Int']['output']
  repliedMyself: Scalars['Boolean']['output']
  replies?: Maybe<Array<CommunityPostReply>>
  repliesHiddenReason?: Maybe<Scalars['String']['output']>
  replyingClosedAt?: Maybe<Scalars['DateTime']['output']>
  replyingStatus: Scalars['String']['output']
}

/** Reply to community post */
export type CommunityPostReply = {
  createdAt: Scalars['DateTime']['output']
  isHidden: Scalars['Boolean']['output']
  isMyReply: Scalars['Boolean']['output']
  postID: Scalars['ID']['output']
  replyID: Scalars['ID']['output']
}

export type CommunityPostReplyAuthor = CommunityFacilitator

/** Hidden community post reply */
export type CommunityPostReplyHidden = {
  __typename?: 'CommunityPostReplyHidden'
  reply: CommunityPostReply
}

/**
 * Input parameters for replying to community post
 *
 * Should contain one of the propeties
 */
export type CommunityPostReplyInput = {
  questionAnswer?: InputMaybe<CommunityPostReplyInputQuestionAnswer>
}

/** Answering to question */
export type CommunityPostReplyInputQuestionAnswer = {
  message: Scalars['String']['input']
}

/** Answer to community question */
export type CommunityPostReplyQuestionAnswer = CommunityPostReply & {
  __typename?: 'CommunityPostReplyQuestionAnswer'
  createdAt: Scalars['DateTime']['output']
  isHidden: Scalars['Boolean']['output']
  isMyReply: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  postID: Scalars['ID']['output']
  replyAuthor?: Maybe<CommunityPostReplyAuthor>
  replyID: Scalars['ID']['output']
}

/** Result of reply sending */
export type CommunityPostReplyResult = CommunityPostReplySended | CommunityPostReplySendingPrevented

/** Reply was sended successfully */
export type CommunityPostReplySended = {
  __typename?: 'CommunityPostReplySended'
  communityPost: CommunityPost
  reply: CommunityPostReply
}

/** Reply sending was prevented */
export type CommunityPostReplySendingPrevented = {
  __typename?: 'CommunityPostReplySendingPrevented'
  communityPost: CommunityPost
  reason: Scalars['String']['output']
}

/** Restored community post reply */
export type CommunityPostReplyUnhidden = {
  __typename?: 'CommunityPostReplyUnhidden'
  reply: CommunityPostReply
}

/** Community posts result */
export type CommunityPostsResult = {
  __typename?: 'CommunityPostsResult'
  posts: Array<CommunityPost>
}

export type ConsentDocument = {
  __typename?: 'ConsentDocument'
  acceptSource?: Maybe<AcceptSource>
  acceptedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['String']['output']
  requiresWrittenAcceptance: Scalars['Boolean']['output']
  title: Scalars['String']['output']
}

export type CostEstimate = {
  __typename?: 'CostEstimate'
  intakeCostEstimateInCents?: Maybe<Scalars['Int']['output']>
  month1CostEstimateInCents?: Maybe<Scalars['Int']['output']>
  month2CostEstimateInCents?: Maybe<Scalars['Int']['output']>
  month3CostEstimateInCents?: Maybe<Scalars['Int']['output']>
  programCostEstimateInCents?: Maybe<Scalars['Int']['output']>
}

export type CostEstimateLookup = CostEstimateLookupFailure | CostEstimateLookupSuccess

export type CostEstimateLookupFailure = {
  __typename?: 'CostEstimateLookupFailure'
  reason: Scalars['String']['output']
}

export type CostEstimateLookupSuccess = {
  __typename?: 'CostEstimateLookupSuccess'
  intakeCostEstimateInCents: Scalars['Int']['output']
  month1CostEstimateInCents: Scalars['Int']['output']
  month2CostEstimateInCents: Scalars['Int']['output']
  month3CostEstimateInCents: Scalars['Int']['output']
}

export type CreateChatMessageResult = ChatMessageCreated

export type CreateEnrollmentAction = {
  __typename?: 'CreateEnrollmentAction'
  patient: Patient
  uid: Scalars['ID']['output']
}

export type CreatePatientFile = {
  __typename?: 'CreatePatientFile'
  file: PatientFile
  method: Scalars['String']['output']
  uploadURL: Scalars['String']['output']
}

export type CreatePatientFileInput = {
  contentType: Scalars['String']['input']
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
}

export type CreateSmsMessageResult = {
  __typename?: 'CreateSmsMessageResult'
  smsMessage?: Maybe<SmsMessage>
}

export type CustomQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  question: Scalars['String']['input']
  questionID: Scalars['String']['input']
}

export type CustomerIoNotificationOpenInput = {
  deliveryID: Scalars['String']['input']
  deviceID: Scalars['String']['input']
}

export type DaysDisengagedIndicator = {
  __typename?: 'DaysDisengagedIndicator'
  /**
   * The number of consecutive days without a completed practice or health questionnaire (setup
   * activities do not count). Days are Meru days in the participant's timezone, counted from the
   * program start date at the earliest.
   */
  days: Scalars['Int']['output']
  level: AppActivityLevel
}

export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
}

export type EditChatMessageResult = ChatMessageEdited

export type Email = {
  __typename?: 'Email'
  createdAt: Scalars['DateTime']['output']
  emailID: Scalars['ID']['output']
  from?: Maybe<Scalars['String']['output']>
  htmlBody?: Maybe<Scalars['String']['output']>
  status: EmailStatus
  statusChangedAt: Scalars['DateTime']['output']
  subject?: Maybe<Scalars['String']['output']>
  textBody?: Maybe<Scalars['String']['output']>
  to: Scalars['String']['output']
}

export enum EmailStatus {
  Bounced = 'BOUNCED',
  Delivered = 'DELIVERED',
  HardBounced = 'HARD_BOUNCED',
  Opened = 'OPENED',
  Sending = 'SENDING',
  SpamComplaint = 'SPAM_COMPLAINT',
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  language?: Maybe<Scalars['String']['output']>
  subject: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type EmailTemplateInput = {
  description: Scalars['String']['input']
  language?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type EmergencyContact = {
  __typename?: 'EmergencyContact'
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type EmergencyContactInput = {
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export enum EngagementType {
  Completer = 'COMPLETER',
  Dropout = 'DROPOUT',
  NoShow = 'NO_SHOW',
}

export type Enrollment = {
  __typename?: 'Enrollment'
  createdAt: Scalars['DateTime']['output']
  enrolledFromPreviousAdvancedProgram: Scalars['Boolean']['output']
  followUpProgram?: Maybe<FollowUpProgram>
  id: Scalars['ID']['output']
  lastStateTransitionAt: Scalars['DateTime']['output']
  programID: Scalars['String']['output']
  programStartDate?: Maybe<Scalars['Date']['output']>
  state: EnrollmentState
  uid: Scalars['ID']['output']
}

export enum EnrollmentState {
  CancellationPending = 'CANCELLATION_PENDING',
  DidNotStart = 'DID_NOT_START',
  IntakeCallScheduled = 'INTAKE_CALL_SCHEDULED',
  IntakeLoggedIn = 'INTAKE_LOGGED_IN',
  IntakePreRegistered = 'INTAKE_PRE_REGISTERED',
  IntakeRegistered = 'INTAKE_REGISTERED',
  InProgram = 'IN_PROGRAM',
  PostProgram = 'POST_PROGRAM',
  Test = 'TEST',
}

/** A link to an app screen listed in the 'Explore more' section. Not a lesson: it has no task or response, so nothing is tracked as completed. */
export type ExploreMoreShortcut = {
  __typename?: 'ExploreMoreShortcut'
  destination: ExploreMoreShortcutDestination
  title: Scalars['String']['output']
}

export enum ExploreMoreShortcutDestination {
  /** @deprecated No longer served. */
  AboutBiofeedback = 'ABOUT_BIOFEEDBACK',
  ProgramExperts = 'PROGRAM_EXPERTS',
}

export type ExternalManager = {
  __typename?: 'ExternalManager'
  email: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  organization: ExternalOrganization
}

export type ExternalOrganization = {
  __typename?: 'ExternalOrganization'
  authServiceID: Scalars['String']['output']
  healthPlans: Array<ExternalOrganizationHealthPlan>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ExternalOrganizationHealthPlan = {
  __typename?: 'ExternalOrganizationHealthPlan'
  healthPlan: Scalars['String']['output']
  state: Scalars['String']['output']
}

export type ExternalOrganizationHealthPlanInput = {
  healthPlan: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type FavoriteLesson = {
  __typename?: 'FavoriteLesson'
  favoriteID: Scalars['ID']['output']
  lessonID: Scalars['String']['output']
}

export type FavoriteLessonAdded = {
  __typename?: 'FavoriteLessonAdded'
  favoriteLessons: FavoriteLessons
}

export type FavoriteLessonRemoved = {
  __typename?: 'FavoriteLessonRemoved'
  favoriteLessons: FavoriteLessons
}

export type FavoriteLessons = {
  __typename?: 'FavoriteLessons'
  lessons: Array<FavoriteLesson>
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
  /** Whether enabled is the coach's own choice rather than the Remote Config value. */
  overridden: Scalars['Boolean']['output']
  /** Whether the signed-in coach can switch this flag on and off for themselves from the dashboard. */
  toggleable: Scalars['Boolean']['output']
}

export type FeatureSeenResult = {
  __typename?: 'FeatureSeenResult'
  featureID: Scalars['String']['output']
  seenAt: Scalars['DateTime']['output']
}

export type FeedItem =
  | ChatMessage
  | LabOrderEvent
  | OverdueQuestionnaire
  | PatientResponse
  | ResumedPatientResponse
  | SmsMessage
  | VideoCall

export enum FeedOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type FeedResult = FeedSuccess

export type FeedSeenResult = {
  __typename?: 'FeedSeenResult'
  patient: Patient
  seenAt: Scalars['DateTime']['output']
}

export type FeedSuccess = {
  __typename?: 'FeedSuccess'
  items: Array<FeedItem>
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>
}

export type FinancialEligibilityCostEstimate = {
  __typename?: 'FinancialEligibilityCostEstimate'
  intakeCostEstimateInCents: Scalars['Int']['output']
  month1CostEstimateInCents: Scalars['Int']['output']
  month2CostEstimateInCents: Scalars['Int']['output']
  month3CostEstimateInCents: Scalars['Int']['output']
}

export type FinancialEligibilityCostEstimateInput = {
  intakeCostEstimateInCents: Scalars['Int']['input']
  month1CostEstimateInCents: Scalars['Int']['input']
  month2CostEstimateInCents: Scalars['Int']['input']
  month3CostEstimateInCents: Scalars['Int']['input']
}

export type FinancialEligibilityInsuranceSubscriberInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>
  coverageActive: Scalars['Boolean']['input']
  firstname: Scalars['String']['input']
  groupDescription?: InputMaybe<Scalars['String']['input']>
  groupNumber?: InputMaybe<Scalars['String']['input']>
  lastname: Scalars['String']['input']
  memberID: Scalars['String']['input']
}

export type FinancialEligibilityPatientHistory = PatientHistory & {
  __typename?: 'FinancialEligibilityPatientHistory'
  coachID?: Maybe<Scalars['ID']['output']>
  costEstimate?: Maybe<FinancialEligibilityCostEstimate>
  createdAt: Scalars['DateTime']['output']
  date?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  entryID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<PatientHistoryType>
}

export type FollowUpProgram = {
  __typename?: 'FollowUpProgram'
  programID?: Maybe<Scalars['String']['output']>
  programOptions: Array<Scalars['String']['output']>
}

export type Gad7Series = AssessmentGraphSeries & {
  __typename?: 'Gad7Series'
  measure: AssessmentMeasure
  points: Array<AssessmentGraphPoint>
}

export type HealthQuestionnaireGad7 = {
  __typename?: 'HealthQuestionnaireGAD7'
  GAD7_QUESTION_1?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_2?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_3?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_4?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_5?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_6?: Maybe<Scalars['Int']['output']>
  GAD7_QUESTION_7?: Maybe<Scalars['Int']['output']>
  GAD7_SCORE?: Maybe<Scalars['Int']['output']>
}

export type HealthQuestionnairePhq9 = {
  __typename?: 'HealthQuestionnairePHQ9'
  PHQ9_QUESTION_1?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_2?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_3?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_4?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_5?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_6?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_7?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_8?: Maybe<Scalars['Int']['output']>
  PHQ9_QUESTION_9?: Maybe<Scalars['Int']['output']>
  PHQ9_SCORE?: Maybe<Scalars['Int']['output']>
}

export type Illustration = {
  __typename?: 'Illustration'
  height: Scalars['Int']['output']
  uri: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type InAppAccountAndSettingsScreen = {
  __typename?: 'InAppAccountAndSettingsScreen'
  cancelPlanScreen?: Maybe<InAppCancelPlanResult>
  myProgramScreen?: Maybe<InAppMyProgramScreen>
  notifications?: Maybe<InAppNotifications>
  paymentsAndPlan?: Maybe<InAppPaymentsAndPlanScreen>
  profileForms?: Maybe<Array<InAppProfileForm>>
  supportSection?: Maybe<InAppSupportSection>
}

export type InAppCancelPlanResult = InAppCancelPlanScreen | InAppPlanCancelledScreen

export type InAppCancelPlanScreen = {
  __typename?: 'InAppCancelPlanScreen'
  cancelPlanButtonCopy: Scalars['String']['output']
  cancelPlanForms: Array<CancelPlanForm>
}

export type InAppChangeTherapist = {
  __typename?: 'InAppChangeTherapist'
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimate = {
  __typename?: 'InAppCostEstimate'
  costEstimate?: Maybe<CostEstimate>
  homeScreen?: Maybe<InAppCostEstimateHomeScreenContent>
  sections: Array<InAppCostEstimateSection>
  settingsScreen?: Maybe<InAppCostEstimateSettingsScreenContent>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimateAlertComponent = {
  __typename?: 'InAppCostEstimateAlertComponent'
  copy: Scalars['String']['output']
}

export type InAppCostEstimateComponent =
  | InAppCostEstimateAlertComponent
  | InAppCostEstimateExpandableComponent
  | InAppCostEstimateFeeGroupComponent
  | InAppCostEstimateHorizontalDividerComponent
  | InAppCostEstimateIconTextListComponent
  | InAppCostEstimateMultiTextInRowComponent
  | InAppCostEstimateParagraphComponent
  | InAppCostEstimateTimelineComponent
  | InAppCostEstimateTitleComponent

export type InAppCostEstimateExpandableComponent = {
  __typename?: 'InAppCostEstimateExpandableComponent'
  items: Array<InAppCostEstimateExpandableComponentItem>
}

export type InAppCostEstimateExpandableComponentItem = {
  __typename?: 'InAppCostEstimateExpandableComponentItem'
  copy: Scalars['String']['output']
  expanded?: Maybe<Scalars['Boolean']['output']>
  title: Scalars['String']['output']
}

export type InAppCostEstimateFeeGroupComponent = {
  __typename?: 'InAppCostEstimateFeeGroupComponent'
  items: Array<InAppCostEstimateFeeGroupComponentItem>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimateFeeGroupComponentItem = {
  __typename?: 'InAppCostEstimateFeeGroupComponentItem'
  cost?: Maybe<Scalars['String']['output']>
  costCoverage?: Maybe<InAppCostEstimateFeeGroupComponentItemCoverage>
  costDisclaimer?: Maybe<Scalars['String']['output']>
  costSuffix?: Maybe<Scalars['String']['output']>
  fullCost?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimateFeeGroupComponentItemCoverage = {
  __typename?: 'InAppCostEstimateFeeGroupComponentItemCoverage'
  copy: Scalars['String']['output']
  style?: Maybe<InAppCostEstimateFeeGroupComponentItemCoverageStyle>
}

export enum InAppCostEstimateFeeGroupComponentItemCoverageStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export type InAppCostEstimateHomeScreenContent = {
  __typename?: 'InAppCostEstimateHomeScreenContent'
  linkCopy?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimateHorizontalDividerComponent = {
  __typename?: 'InAppCostEstimateHorizontalDividerComponent'
  _?: Maybe<Scalars['Boolean']['output']>
}

export enum InAppCostEstimateIcon {
  Calendar = 'CALENDAR',
  Checkmark = 'CHECKMARK',
  DollarSign = 'DOLLAR_SIGN',
  EyeOff = 'EYE_OFF',
  Flag = 'FLAG',
  Heart = 'HEART',
  LessonMindfulness = 'LESSON_MINDFULNESS',
  LessonVideo = 'LESSON_VIDEO',
  NavChat = 'NAV_CHAT',
  Star = 'STAR',
}

export type InAppCostEstimateIconTextListComponent = {
  __typename?: 'InAppCostEstimateIconTextListComponent'
  items: Array<InAppCostEstimateIconTextListComponentItem>
}

export type InAppCostEstimateIconTextListComponentItem = {
  __typename?: 'InAppCostEstimateIconTextListComponentItem'
  copy: Scalars['String']['output']
  /** @deprecated use iconName */
  icon: InAppCostEstimateIcon
  iconName: Scalars['String']['output']
}

export type InAppCostEstimateMultiTextInRowComponent = {
  __typename?: 'InAppCostEstimateMultiTextInRowComponent'
  items: Array<InAppCostEstimateMultiTextInRowComponentItem>
}

export type InAppCostEstimateMultiTextInRowComponentItem = {
  __typename?: 'InAppCostEstimateMultiTextInRowComponentItem'
  copy: Scalars['String']['output']
  style?: Maybe<InAppCostEstimateMultiTextInRowComponentItemStyle>
}

export enum InAppCostEstimateMultiTextInRowComponentItemStyle {
  H1 = 'H1',
  H5 = 'H5',
}

export type InAppCostEstimateParagraphComponent = {
  __typename?: 'InAppCostEstimateParagraphComponent'
  copy: Scalars['String']['output']
}

export type InAppCostEstimateSection = {
  __typename?: 'InAppCostEstimateSection'
  components: Array<InAppCostEstimateComponent>
  style?: Maybe<InAppCostEstimateSectionStyle>
}

export enum InAppCostEstimateSectionStyle {
  Bordered = 'BORDERED',
  Plain = 'PLAIN',
}

export type InAppCostEstimateSettingsScreenContent = {
  __typename?: 'InAppCostEstimateSettingsScreenContent'
  linkCopy?: Maybe<Scalars['String']['output']>
}

export type InAppCostEstimateTimelineComponent = {
  __typename?: 'InAppCostEstimateTimelineComponent'
  items: Array<InAppCostEstimateTimelineComponentItem>
}

export type InAppCostEstimateTimelineComponentItem = {
  __typename?: 'InAppCostEstimateTimelineComponentItem'
  copy: Scalars['String']['output']
  /** @deprecated use iconName */
  icon: InAppCostEstimateIcon
  iconName: Scalars['String']['output']
}

export type InAppCostEstimateTitleComponent = {
  __typename?: 'InAppCostEstimateTitleComponent'
  style?: Maybe<InAppCostEstimateTitleComponentStyle>
  title: Scalars['String']['output']
}

export enum InAppCostEstimateTitleComponentStyle {
  H3 = 'H3',
  H5 = 'H5',
}

export type InAppEnabledTabs = {
  __typename?: 'InAppEnabledTabs'
  chat: Scalars['Boolean']['output']
  community: Scalars['Boolean']['output']
  /** True when the patient's program supports the Progress tab. The client uses this to render the Progress tab in the bottom navigation bar. */
  progress: Scalars['Boolean']['output']
  tabBar: Scalars['Boolean']['output']
  timeline: Scalars['Boolean']['output']
}

export type InAppGetSupport = {
  __typename?: 'InAppGetSupport'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type InAppGiveFeedback = {
  __typename?: 'InAppGiveFeedback'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type InAppIntakeHomeActivity = {
  __typename?: 'InAppIntakeHomeActivity'
  icon?: Maybe<InAppIntakeHomeActivityIcon>
  lessonID: Scalars['ID']['output']
  response?: Maybe<PatientResponse>
  taskID: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export enum InAppIntakeHomeActivityIcon {
  Learn = 'LEARN',
  Reflect = 'REFLECT',
  Therapist = 'THERAPIST',
}

export type InAppIntakeHomePostIntakeMessage = {
  __typename?: 'InAppIntakeHomePostIntakeMessage'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type InAppIntakeHomeScreen = {
  __typename?: 'InAppIntakeHomeScreen'
  activities: Array<InAppIntakeHomeActivity>
  /** Present once the intake call has taken place and the participant is still waiting to be accepted into the program. */
  postIntakeMessage?: Maybe<InAppIntakeHomePostIntakeMessage>
  therapistProfile?: Maybe<InAppIntakeHomeTherapistProfile>
  title: Scalars['String']['output']
}

export type InAppIntakeHomeTherapistProfile = {
  __typename?: 'InAppIntakeHomeTherapistProfile'
  buttonText: Scalars['String']['output']
  icon?: Maybe<InAppIntakeHomeActivityIcon>
}

export type InAppMyProgramLesson = {
  __typename?: 'InAppMyProgramLesson'
  icon?: Maybe<Scalars['String']['output']>
  lessonID: Scalars['ID']['output']
  taskID: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export type InAppMyProgramScreen = {
  __typename?: 'InAppMyProgramScreen'
  lessons: Array<InAppMyProgramLesson>
}

export type InAppNotifications = {
  __typename?: 'InAppNotifications'
  description?: Maybe<Scalars['String']['output']>
  icon?: Maybe<InAppNotificationsIcon>
  phoneNotificationAlert?: Maybe<InAppPhoneNotificationAlert>
  title?: Maybe<Scalars['String']['output']>
  toggleCopy?: Maybe<Scalars['String']['output']>
}

export enum InAppNotificationsIcon {
  Bell = 'BELL',
}

export type InAppPaymentInformation = AllPaymentsCompleted | PaymentSummary | UpcomingPayment

export type InAppPaymentInformationResult = {
  __typename?: 'InAppPaymentInformationResult'
  aperoPaymentInformation?: Maybe<AperoPaymentInformation>
  paymentInformation?: Maybe<InAppPaymentInformation>
  paymentMethod?: Maybe<InAppPaymentMethod>
}

export type InAppPaymentMethod = {
  __typename?: 'InAppPaymentMethod'
  authorizeCard?: Maybe<InAppPaymentPlanScreenPaymentMethodAuthorizeCard>
  authorizeCardSuccess?: Maybe<InAppPaymentPlanScreenPaymentMethodAuthorizeCardSuccess>
  cardInfo?: Maybe<InAppPaymentPlanScreenPaymentMethodCardInfo>
  changeCardOption?: Maybe<InAppPaymentPlanScreenPaymentMethodChangeCardOption>
  copy?: Maybe<Scalars['String']['output']>
  paymentMethodStatus?: Maybe<PaymentMethodStatus>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentPlanScreenPaymentMethodAuthorizeCard = {
  __typename?: 'InAppPaymentPlanScreenPaymentMethodAuthorizeCard'
  annotation?: Maybe<Scalars['String']['output']>
  buttonCopy?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentPlanScreenPaymentMethodAuthorizeCardSuccess = {
  __typename?: 'InAppPaymentPlanScreenPaymentMethodAuthorizeCardSuccess'
  buttonCopy?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentPlanScreenPaymentMethodCardInfo = {
  __typename?: 'InAppPaymentPlanScreenPaymentMethodCardInfo'
  expiryDateCopy?: Maybe<Scalars['String']['output']>
  issuer?: Maybe<Scalars['String']['output']>
  lastFourDigitsCopy?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentPlanScreenPaymentMethodChangeCardOption = {
  __typename?: 'InAppPaymentPlanScreenPaymentMethodChangeCardOption'
  confirmActionButtonCopy?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  initialActionButtonCopy?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentPlanScreenSupportContact = {
  __typename?: 'InAppPaymentPlanScreenSupportContact'
  annotation?: Maybe<Scalars['String']['output']>
  buttonCopy?: Maybe<Scalars['String']['output']>
  supportEmail?: Maybe<Scalars['String']['output']>
}

export type InAppPaymentsAndPlanScreen = {
  __typename?: 'InAppPaymentsAndPlanScreen'
  faq?: Maybe<InAppPaymentsFaq>
  programSummary?: Maybe<InAppPaymentsProgramSummary>
  supportContact?: Maybe<InAppPaymentPlanScreenSupportContact>
  title: Scalars['String']['output']
}

export type InAppPaymentsFaq = {
  __typename?: 'InAppPaymentsFAQ'
  components: Array<InAppCostEstimateComponent>
}

export type InAppPaymentsPlanCancelPlanButton = {
  __typename?: 'InAppPaymentsPlanCancelPlanButton'
  buttonCopy: Scalars['String']['output']
}

export type InAppPaymentsProgramSummary = {
  __typename?: 'InAppPaymentsProgramSummary'
  cancelPlanButton?: Maybe<InAppPaymentsPlanCancelPlanButton>
  components: Array<InAppCostEstimateComponent>
}

export type InAppPhoneNotificationAlert = {
  __typename?: 'InAppPhoneNotificationAlert'
  actionButton?: Maybe<InAppPhoneNotificationAlertActionButton>
  description?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export enum InAppPhoneNotificationAlertAction {
  GoToSettings = 'GO_TO_SETTINGS',
}

export type InAppPhoneNotificationAlertActionButton = {
  __typename?: 'InAppPhoneNotificationAlertActionButton'
  action: InAppPhoneNotificationAlertAction
  label: Scalars['String']['output']
}

export type InAppPlanCancelledScreen = {
  __typename?: 'InAppPlanCancelledScreen'
  buttonCopy?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  illustrationURL?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppProfileForm = {
  __typename?: 'InAppProfileForm'
  completionStatusIcon?: Maybe<InAppProfileFormCompletionStatusIcon>
  enableUnseenIcon?: Maybe<Scalars['Boolean']['output']>
  icon?: Maybe<InAppProfileFormIcon>
  id: Scalars['ID']['output']
  sections: Array<InAppProfileFormSection>
  seenStatus?: Maybe<FeatureSeenResult>
  subTitle?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type InAppProfileFormCheckbox = {
  __typename?: 'InAppProfileFormCheckbox'
  /** Optional inline link + sheet that explains the checkbox (e.g. a consent's full text). */
  details?: Maybe<InAppProfileFormCheckboxDetails>
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
  /** Stringified boolean (true when checked) to match the framework string value model. */
  value?: Maybe<Scalars['String']['output']>
}

export type InAppProfileFormCheckboxDetails = {
  __typename?: 'InAppProfileFormCheckboxDetails'
  body: Scalars['String']['output']
  linkText: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum InAppProfileFormCompletionStatusIcon {
  Success = 'SUCCESS',
  Warning = 'WARNING',
}

export type InAppProfileFormFieldInput = {
  id: Scalars['String']['input']
  valueDate?: InputMaybe<Scalars['Date']['input']>
  valueProviderIdentifier?: InputMaybe<InAppProfileFormProviderIdentifierValueInput>
  valueString?: InputMaybe<Scalars['String']['input']>
  valueStringArray?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum InAppProfileFormIcon {
  EmergencyContact = 'EMERGENCY_CONTACT',
  Insurance = 'INSURANCE',
  MyProfile = 'MY_PROFILE',
  PrimaryCareProvider = 'PRIMARY_CARE_PROVIDER',
  SelfIdentification = 'SELF_IDENTIFICATION',
  ShippingAddress = 'SHIPPING_ADDRESS',
}

export type InAppProfileFormInputField =
  | InAppProfileFormCheckbox
  | InAppProfileFormMultiItemSelector
  | InAppProfileFormProviderIdentifier
  | InAppProfileFormSingleItemSelector
  | InAppProfileFormTextInput

export type InAppProfileFormItemSelector = {
  id: Scalars['ID']['output']
  itemsList: InAppProfileFormItemSelectorItemsList
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
}

export type InAppProfileFormItemSelectorItem = {
  __typename?: 'InAppProfileFormItemSelectorItem'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type InAppProfileFormItemSelectorItemsList = {
  __typename?: 'InAppProfileFormItemSelectorItemsList'
  items: Array<InAppProfileFormItemSelectorItem>
  saveButtonLabel: Scalars['String']['output']
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppProfileFormMultiItemSelector = InAppProfileFormItemSelector & {
  __typename?: 'InAppProfileFormMultiItemSelector'
  id: Scalars['ID']['output']
  itemsList: InAppProfileFormItemSelectorItemsList
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
  value?: Maybe<Array<Scalars['String']['output']>>
}

export type InAppProfileFormProviderIdentifier = InAppProfileFormItemSelector & {
  __typename?: 'InAppProfileFormProviderIdentifier'
  id: Scalars['ID']['output']
  /** Identifier types the patient can pick from; the selection is part of the value. */
  itemsList: InAppProfileFormItemSelectorItemsList
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
  value?: Maybe<InAppProfileFormProviderIdentifierValue>
}

export type InAppProfileFormProviderIdentifierValue = {
  __typename?: 'InAppProfileFormProviderIdentifierValue'
  identifier: Scalars['String']['output']
  /** Identifier type; matches one of the itemsList item values. */
  type: Scalars['String']['output']
}

export type InAppProfileFormProviderIdentifierValueInput = {
  identifier: Scalars['String']['input']
  /** Identifier type; matches one of the provider identifier itemsList item values. */
  type: Scalars['String']['input']
}

export type InAppProfileFormSection = {
  __typename?: 'InAppProfileFormSection'
  id: Scalars['ID']['output']
  inputFields: Array<InAppProfileFormInputField>
  subTitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type InAppProfileFormSingleItemSelector = InAppProfileFormItemSelector & {
  __typename?: 'InAppProfileFormSingleItemSelector'
  id: Scalars['ID']['output']
  itemsList: InAppProfileFormItemSelectorItemsList
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type InAppProfileFormTextInput = {
  __typename?: 'InAppProfileFormTextInput'
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  readOnly: Scalars['Boolean']['output']
  required?: Maybe<Scalars['Boolean']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type InAppProfileFormUpdateResult = {
  __typename?: 'InAppProfileFormUpdateResult'
  updatedField?: Maybe<InAppProfileFormInputField>
}

export type InAppPromptActionPanelActionButton = InAppPromptActionPanelActionButtonDeepLink

export type InAppPromptActionPanelActionButtonDeepLink = {
  __typename?: 'InAppPromptActionPanelActionButtonDeepLink'
  actionName: Scalars['String']['output']
  copy: Scalars['String']['output']
  deepLink: Scalars['String']['output']
}

export enum InAppPromptActionPanelIcon {
  Warning = 'WARNING',
}

export type InAppPromptActionPanelResult = {
  __typename?: 'InAppPromptActionPanelResult'
  annotation?: Maybe<Scalars['String']['output']>
  button?: Maybe<InAppPromptActionPanelActionButton>
  copy?: Maybe<Scalars['String']['output']>
  icon?: Maybe<InAppPromptActionPanelIcon>
  id: Scalars['String']['output']
}

export type InAppRating = {
  __typename?: 'InAppRating'
  followUpQuestionnaire?: Maybe<InAppRatingFollowUpQuestionnaire>
  id: Scalars['ID']['output']
  illustrationUrl?: Maybe<Scalars['String']['output']>
  question: InAppRatingQuestion
  score?: Maybe<Scalars['Int']['output']>
}

export type InAppRatingFollowUpQuestionnaire = {
  __typename?: 'InAppRatingFollowUpQuestionnaire'
  buttonLabel: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type InAppRatingQuestion = {
  __typename?: 'InAppRatingQuestion'
  annotation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  maxScore: Scalars['Int']['output']
  title: Scalars['String']['output']
}

export type InAppSignupFormFound = {
  __typename?: 'InAppSignupFormFound'
  form: SignupForm
}

export type InAppSignupFormInput = {
  accessCode?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type InAppSignupFormNotFound = {
  __typename?: 'InAppSignupFormNotFound'
  accessCode?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
}

export type InAppSignupFormResult = InAppSignupFormFound | InAppSignupFormNotFound

export type InAppStripeConfig = {
  __typename?: 'InAppStripeConfig'
  publishableKey: Scalars['String']['output']
}

export type InAppSupportSection = {
  __typename?: 'InAppSupportSection'
  changeTherapist?: Maybe<InAppChangeTherapist>
  getSupport?: Maybe<InAppGetSupport>
  giveFeedback?: Maybe<InAppGiveFeedback>
  title: Scalars['String']['output']
}

export type InAppTabIntroduction = {
  __typename?: 'InAppTabIntroduction'
  newTabIntroductionEnabled?: Maybe<Scalars['Boolean']['output']>
  programStepperEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallBanner = {
  __typename?: 'InAppVideoCallBanner'
  copy: Scalars['String']['output']
  isPressable?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallBookCallAction = {
  __typename?: 'InAppVideoCallBookCallAction'
  copy: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
  lessonID: Scalars['String']['output']
}

export type InAppVideoCallCallJoinDetails = {
  __typename?: 'InAppVideoCallCallJoinDetails'
  meetingID?: Maybe<Scalars['String']['output']>
  meetingUrl?: Maybe<Scalars['String']['output']>
}

export type InAppVideoCallCancelCallAction = {
  __typename?: 'InAppVideoCallCancelCallAction'
  callID: Scalars['String']['output']
  confirmation?: Maybe<InAppVideoCallCancelCallConfirmation>
  copy: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallCancelCallConfirmation = {
  __typename?: 'InAppVideoCallCancelCallConfirmation'
  confirmCopy: Scalars['String']['output']
  copy: Scalars['String']['output']
  declineCopy: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type InAppVideoCallCard = {
  __typename?: 'InAppVideoCallCard'
  callDate?: Maybe<Scalars['String']['output']>
  callTimeRange?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  disclaimer: Scalars['String']['output']
  joinCallAction?: Maybe<InAppVideoCallJoinCallAction>
  subtitle?: Maybe<Scalars['String']['output']>
  subtitleIcon?: Maybe<InAppVideoCallCardIcon>
}

export enum InAppVideoCallCardIcon {
  Together = 'TOGETHER',
}

export type InAppVideoCallChatHeader = {
  __typename?: 'InAppVideoCallChatHeader'
  copy: Scalars['String']['output']
  joinCallAction?: Maybe<InAppVideoCallJoinCallAction>
  openCallDetailsAction?: Maybe<InAppVideoCallOpenCallDetailsAction>
}

export type InAppVideoCallJoinCallAction = {
  __typename?: 'InAppVideoCallJoinCallAction'
  callJoinDetails?: Maybe<InAppVideoCallCallJoinDetails>
  copy: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallModal = {
  __typename?: 'InAppVideoCallModal'
  cancelCallAction?: Maybe<InAppVideoCallCancelCallAction>
  content?: Maybe<InAppVideoCallModalContent>
  footer?: Maybe<InAppVideoCallModalFooter>
  joinCallAction?: Maybe<InAppVideoCallJoinCallAction>
  openAutomatically?: Maybe<Scalars['Boolean']['output']>
  rescheduleCallAction?: Maybe<InAppVideoCallRescheduleCallAction>
  title: Scalars['String']['output']
}

export type InAppVideoCallModalContent = {
  __typename?: 'InAppVideoCallModalContent'
  callTime?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  illustrationUrl?: Maybe<Scalars['String']['output']>
}

export type InAppVideoCallModalFooter = {
  __typename?: 'InAppVideoCallModalFooter'
  copy: Scalars['String']['output']
}

export type InAppVideoCallOpenCallDetailsAction = {
  __typename?: 'InAppVideoCallOpenCallDetailsAction'
  copy: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallRescheduleCallAction = {
  __typename?: 'InAppVideoCallRescheduleCallAction'
  callID: Scalars['String']['output']
  confirmation?: Maybe<InAppVideoCallRescheduleCallConfirmation>
  copy: Scalars['String']['output']
  disabled?: Maybe<Scalars['Boolean']['output']>
}

export type InAppVideoCallRescheduleCallConfirmation = {
  __typename?: 'InAppVideoCallRescheduleCallConfirmation'
  confirmCopy: Scalars['String']['output']
  copy: Scalars['String']['output']
  declineCopy: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type InAppVideoCallResult = {
  __typename?: 'InAppVideoCallResult'
  banner?: Maybe<InAppVideoCallBanner>
  bookCallAction?: Maybe<InAppVideoCallBookCallAction>
  card?: Maybe<InAppVideoCallCard>
  chatHeader?: Maybe<InAppVideoCallChatHeader>
  modal?: Maybe<InAppVideoCallModal>
  refreshAt?: Maybe<Scalars['DateTime']['output']>
  status?: Maybe<InAppVideoCallStatus>
  videoCall?: Maybe<VideoCall>
}

export enum InAppVideoCallStatus {
  NotScheduled = 'NOT_SCHEDULED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED',
  ScheduledToday = 'SCHEDULED_TODAY',
}

export type InProgramVideoCallBookingInformation = {
  __typename?: 'InProgramVideoCallBookingInformation'
  callBookingEnabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  latestCallHad?: Maybe<VideoCall>
  numberOfCallsHad?: Maybe<Scalars['Int']['output']>
  uncancelledCalls: Array<VideoCall>
  videoCalls: Array<VideoCall>
}

export type InsuranceSubscriber = {
  __typename?: 'InsuranceSubscriber'
  birthDate?: Maybe<Scalars['Date']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
}

export type InsuranceSubscriberOfDependentInput = {
  dateOfBirth: Scalars['Date']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type IntakeNoteComprehensiveHealthQuestionnaire = {
  __typename?: 'IntakeNoteComprehensiveHealthQuestionnaire'
  gad7?: Maybe<HealthQuestionnaireGad7>
  phq9?: Maybe<HealthQuestionnairePhq9>
}

export type IntakeNoteComprehensiveOverallInformation = {
  __typename?: 'IntakeNoteComprehensiveOverallInformation'
  callEndTime?: Maybe<Scalars['String']['output']>
  callStartTime?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  licenseType?: Maybe<Scalars['String']['output']>
  memberID?: Maybe<Scalars['String']['output']>
  providerName?: Maybe<Scalars['String']['output']>
}

export type IntakeNoteComprehensivePatientAnswer = {
  __typename?: 'IntakeNoteComprehensivePatientAnswer'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  data: PatientAnswerData
  id: Scalars['ID']['output']
  uid: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type IntakeNoteComprehensivePatientData = {
  __typename?: 'IntakeNoteComprehensivePatientData'
  healthQuestionnaire?: Maybe<IntakeNoteComprehensiveHealthQuestionnaire>
  id: Scalars['ID']['output']
  overallInformation?: Maybe<IntakeNoteComprehensiveOverallInformation>
  patientAnswers?: Maybe<IntakeNoteComprehensivePatientAnswer>
}

export type IntakeNoteEmployment = {
  __typename?: 'IntakeNoteEmployment'
  STATUS?: Maybe<IntakeNoteEmploymentStatus>
}

export enum IntakeNoteEmploymentStatus {
  Disabled = 'DISABLED',
  Retired = 'RETIRED',
  StayAtHomeParent = 'STAY_AT_HOME_PARENT',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED',
  Working = 'WORKING',
}

export type IntakeNoteHealthHistory = {
  __typename?: 'IntakeNoteHealthHistory'
  BIPOLAR: Scalars['Boolean']['output']
  DEPRESSION: Scalars['Boolean']['output']
  DTD: Scalars['Boolean']['output']
  GENERALISED_ANXIETY: Scalars['Boolean']['output']
  PSYCHOSIS: Scalars['Boolean']['output']
  PTSD: Scalars['Boolean']['output']
  SUBSTANCE_ABUSE: Scalars['Boolean']['output']
  SUICIDALITY: Scalars['Boolean']['output']
  THERAPY: Scalars['Boolean']['output']
}

export type IntakeVideoCallBookingInformation = {
  __typename?: 'IntakeVideoCallBookingInformation'
  id: Scalars['ID']['output']
  videoCall?: Maybe<VideoCall>
}

export type LabOrder = {
  __typename?: 'LabOrder'
  orderID: Scalars['ID']['output']
  resultPdf?: Maybe<Scalars['Byte']['output']>
}

export type LabOrderEvent = {
  __typename?: 'LabOrderEvent'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  eventID: Scalars['ID']['output']
  events: Array<LabOrderSubEvent>
  occuredAt: Scalars['DateTime']['output']
  orderID: Scalars['ID']['output']
  results?: Maybe<Scalars['JSON']['output']>
  status: LabOrderStatus
  uid: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type LabOrderPatientHistory = PatientHistory & {
  __typename?: 'LabOrderPatientHistory'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  date?: Maybe<Scalars['String']['output']>
  entryID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  labOrder?: Maybe<LabOrder>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<PatientHistoryType>
}

export enum LabOrderStatus {
  Cancelled = 'CANCELLED',
  CollectingSample = 'COLLECTING_SAMPLE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Received = 'RECEIVED',
  SampleWithLab = 'SAMPLE_WITH_LAB',
}

export type LabOrderSubEvent = {
  __typename?: 'LabOrderSubEvent'
  occuredAt: Scalars['DateTime']['output']
  status: Scalars['String']['output']
}

export type Lesson = {
  __typename?: 'Lesson'
  category: LessonCategory
  duration: Scalars['Int']['output']
  id: Scalars['ID']['output']
  programID: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export enum LessonCategory {
  Cbt = 'CBT',
  Default = 'DEFAULT',
  GroupReflection = 'GROUP_REFLECTION',
  HealthQuestionnaire = 'HEALTH_QUESTIONNAIRE',
  MeditationHrv = 'MEDITATION_HRV',
  MeditationMindfulness = 'MEDITATION_MINDFULNESS',
  PersonalReflection = 'PERSONAL_REFLECTION',
  Setup = 'SETUP',
  VideoIntroduction = 'VIDEO_INTRODUCTION',
  VideoRecap = 'VIDEO_RECAP',
  VideoTips = 'VIDEO_TIPS',
}

export type LookupPatientByEmailPatient = {
  __typename?: 'LookupPatientByEmailPatient'
  birthDate?: Maybe<Scalars['Date']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  healthPlan?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  memberID?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  stateOfResidence?: Maybe<Scalars['String']['output']>
  uid: Scalars['ID']['output']
}

export type LookupPatientByEmailResult = {
  __typename?: 'LookupPatientByEmailResult'
  patient?: Maybe<LookupPatientByEmailPatient>
  status: LookupPatientByEmailStatus
}

export enum LookupPatientByEmailStatus {
  IntakePreRegistered = 'INTAKE_PRE_REGISTERED',
  NotFound = 'NOT_FOUND',
  PatientAlreadyExists = 'PATIENT_ALREADY_EXISTS',
}

export type MarkChatMessagesAsSeenResult = UnseenChatMessages

export type MedicalReport = {
  __typename?: 'MedicalReport'
  url: Scalars['String']['output']
  warning?: Maybe<Scalars['String']['output']>
}

export enum MessageOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type ModuleGoal = {
  __typename?: 'ModuleGoal'
  achievedAt?: Maybe<Scalars['Date']['output']>
  practiceGoal: PracticeGoal
}

export type MonthlySummaryNoteIndicator = {
  __typename?: 'MonthlySummaryNoteIndicator'
  count: Scalars['Int']['output']
  showIndicator: Scalars['Boolean']['output']
  showToast: Scalars['Boolean']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  addExternalOrganization: ExternalOrganization
  addFavoriteLesson: FavoriteLessonAdded
  addFinancialEligibilityPatientHistory: PatientHistory
  addHealthPlansToExternalOrganization: ExternalOrganization
  addPatient: Patient
  addPatientAsInProgram: Patient
  addPatientHistory: PatientHistory
  addTagToPatient?: Maybe<AddTagToPatientAction>
  addTestUser: Patient
  answerInAppRating: AnswerInAppRatingResult
  assignQuestionnaireToPatient: QuestionnaireAssignment
  cancelPlan: CancelPlanResult
  cancelVideoCallByCoach?: Maybe<Scalars['Void']['output']>
  cancelVideoCallByParticipant: CancelVideoCallByParticipantResult
  changeAccessLevel: Session
  createChatMessage: CreateChatMessageResult
  createCoach: CoachProfile
  /** Create new community post */
  createCommunityPost: CommunityPostCreated
  createPatientFile: CreatePatientFile
  createPatientTag: PatientTag
  /**
   * A coach's message to the patient's chat for a care-team role they hold, opening the chat if the patient has not.
   * Sent, notified and audited like createChatMessage.
   */
  createRoleChatMessage: CreateChatMessageResult
  createSmsMessage: CreateSmsMessageResult
  deleteCoach?: Maybe<CoachProfile>
  deletePatient?: Maybe<Patient>
  deletePatientHistory?: Maybe<PatientHistory>
  deletePatientTag?: Maybe<Scalars['Void']['output']>
  editChatMessage: EditChatMessageResult
  financialEligibilityLookup: PatientFinancialEligibilityCheck
  /** The signed-in patient's chat with this care-team role, created on first use. */
  findOrCreateAdvancedChat: AdvancedChat
  hideCommunityPostReply: CommunityPostReplyHidden
  inAppProfileFormUpdate: InAppProfileFormUpdateResult
  login?: Maybe<Session>
  logout?: Maybe<Scalars['Void']['output']>
  markChatMessagesAsSeen: MarkChatMessagesAsSeenResult
  markFeatureSeen: FeatureSeenResult
  markFeedSeen: FeedSeenResult
  /**
   * Moves the authenticated coach's last-seen marker for this feed to just before `from`, so
   * every feed entry from `from` on counts as unread again.
   */
  markFeedUnreadFrom: FeedSeenResult
  refreshAccessToken: Session
  registerOnboardingPatient: OnboardingPatient
  registerParticipant: ParticipantRegistrationResult
  removeFavoriteLesson: FavoriteLessonRemoved
  removeQuestionnaireAssignment?: Maybe<Scalars['Void']['output']>
  removeTagFromPatient?: Maybe<Scalars['Void']['output']>
  /** Reply to community post */
  replyToCommunityPost?: Maybe<CommunityPostReplyResult>
  rescheduleInProgramCallByCoach?: Maybe<Scalars['Void']['output']>
  rescheduleIntakeCall?: Maybe<Scalars['Void']['output']>
  rescheduleVideoCallByParticipant: RescheduleVideoCallByParticipantResult
  restartIntake?: Maybe<Scalars['Void']['output']>
  restartPatientInProgram: CreateEnrollmentAction
  /**
   * Runs the patientFile safety checks and records that an Advanced care-team chat message references
   * these files, so patientFilesCleanup stops treating them as orphans. Call before writing the message.
   */
  retainAdvancedChatFiles: Array<PatientFile>
  retryLabOrder: LabOrder
  savePushNotificationToken: SavePushNotificationTokenResult
  scheduleVideoCallByCareCoordinator: VideoCall
  scheduleVideoCallByCoach: ScheduleVideoCallResult
  scheduleVideoCallByExternalManager: VideoCall
  scheduleVideoCallByParticipant: ScheduleVideoCallByParticipantResult
  sendEmails?: Maybe<Scalars['Void']['output']>
  sendParticipantBackToCallScheduling: CreateEnrollmentAction
  setCallException?: Maybe<VideoCall>
  setCareteam: SetCareteamAction
  /**
   * Switches a toggleable feature flag on or off for the signed-in coach. The choice is stored,
   * so it survives reloads and new sessions. Returns the coach's feature flags after the change.
   */
  setFeatureFlagOverride: Array<FeatureFlag>
  setInProgramCallBookingEnabled: InProgramVideoCallBookingInformation
  setModuleGoal: ModuleGoal
  setPatientAccepted: PatientHistory
  setPatientDeclinedV2: PatientHistory
  setPatientProgramEnd: PatientHistory
  setSelfCareReminder: SelfCareReminder
  shiftPatientProgramStartDate: Patient
  stopSelfCareReminder?: Maybe<SelfCareReminder>
  storeMeditationDuration?: Maybe<StoreMeditationDurationResult>
  storePatientResponse?: Maybe<StorePatientResponseResult>
  storePaymentMethod: StorePaymentMethodResult
  submitCallNotes?: Maybe<Scalars['Void']['output']>
  trackAppOpen: TrackAppOpenResult
  trackAppUsageSessions: TrackAppUsageSessionsResult
  trackPushNotificationOpen: TrackPushNotificationOpenResult
  trackPushNotificationPermissionStatus: TrackPushNotificationPermissionStatusResult
  unhideCommunityPostReply: CommunityPostReplyUnhidden
  updateABTestAssignments: Patient
  updateCallNotes?: Maybe<VideoCall>
  updateCoachEmail: CoachProfile
  updateLanguage: ParticipantProfile
  /** Updates the onboarding patient's core information. */
  updateOnboardingPatient: OnboardingPatient
  updatePatient: Patient
  updatePatientByExternalManager: Patient
  updatePatientFile: PatientFile
  /** Patch-style mutation to update patient integrations. Supports updating one field at a time. */
  updatePatientIntegrations: Patient
  /** Updates the onboarding patient's program using a program path (coaching, advanced, or defaults to therapy). */
  updatePatientProgram: OnboardingPatient
  updatePatientProgramStartDate: Patient
  updatePatientQuickNote: Patient
  updateProgramStartDate?: Maybe<Enrollment>
  /** Updates the onboarding patient's source and state of residence. */
  updateSourceAndStateOfResidence: OnboardingPatient
}

export type MutationAddExternalOrganizationArgs = {
  authServiceID: Scalars['String']['input']
  healthPlans: Array<ExternalOrganizationHealthPlanInput>
  name: Scalars['String']['input']
}

export type MutationAddFavoriteLessonArgs = {
  lessonID: Scalars['String']['input']
}

export type MutationAddFinancialEligibilityPatientHistoryArgs = {
  costEstimate?: InputMaybe<FinancialEligibilityCostEstimateInput>
  date: Scalars['Date']['input']
  description: Scalars['String']['input']
  insuranceSubscriber?: InputMaybe<FinancialEligibilityInsuranceSubscriberInput>
  uid: Scalars['ID']['input']
}

export type MutationAddHealthPlansToExternalOrganizationArgs = {
  externalOrganizationID: Scalars['String']['input']
  healthPlans: Array<ExternalOrganizationHealthPlanInput>
}

export type MutationAddPatientArgs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>
  email: Scalars['EmailAddress']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  memberID?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>
  programID?: InputMaybe<Scalars['String']['input']>
  referralName: Scalars['String']['input']
  region: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type MutationAddPatientAsInProgramArgs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>
  email: Scalars['EmailAddress']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  memberID?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>
  programID?: InputMaybe<Scalars['String']['input']>
  referralName: Scalars['String']['input']
  region: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type MutationAddPatientHistoryArgs = {
  date: Scalars['String']['input']
  fileIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  references?: InputMaybe<PatientHistoryReferencesInput>
  type: PatientHistoryType
  uid: Scalars['ID']['input']
  value: Scalars['JSONObject']['input']
}

export type MutationAddTagToPatientArgs = {
  tagID: Scalars['ID']['input']
  uid: Scalars['ID']['input']
}

export type MutationAddTestUserArgs = {
  email: Scalars['EmailAddress']['input']
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  primaryCoachID: Scalars['ID']['input']
  programID: Scalars['String']['input']
  programStartDate: Scalars['String']['input']
}

export type MutationAnswerInAppRatingArgs = {
  questionID: Scalars['ID']['input']
  score: Scalars['Int']['input']
}

export type MutationAssignQuestionnaireToPatientArgs = {
  questionnaire: AssignableQuestionnaire
  repeatCadenceInDays?: InputMaybe<Scalars['Int']['input']>
  uid: Scalars['ID']['input']
}

export type MutationCancelPlanArgs = {
  cancellationReasons: Array<CancellationReasons>
  feedback: Scalars['String']['input']
}

export type MutationCancelVideoCallByCoachArgs = {
  callID: Scalars['ID']['input']
}

export type MutationCancelVideoCallByParticipantArgs = {
  callID: Scalars['String']['input']
}

export type MutationChangeAccessLevelArgs = {
  level: AccessLevel
}

export type MutationCreateChatMessageArgs = {
  advancedChatID?: InputMaybe<Scalars['ID']['input']>
  fileIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  linksTo?: InputMaybe<ChatMessageLinksToInput>
  text: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationCreateCoachArgs = {
  email: Scalars['String']['input']
}

export type MutationCreateCommunityPostArgs = {
  communityID: Scalars['ID']['input']
  post: CommunityPostInput
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  title: Scalars['String']['input']
}

export type MutationCreatePatientFileArgs = {
  input: CreatePatientFileInput
  uid: Scalars['ID']['input']
}

export type MutationCreatePatientTagArgs = {
  name: Scalars['String']['input']
}

export type MutationCreateRoleChatMessageArgs = {
  fileIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  linksTo?: InputMaybe<ChatMessageLinksToInput>
  role: Scalars['String']['input']
  text: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationCreateSmsMessageArgs = {
  text: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationDeleteCoachArgs = {
  coachID: Scalars['ID']['input']
}

export type MutationDeletePatientArgs = {
  uid: Scalars['ID']['input']
}

export type MutationDeletePatientHistoryArgs = {
  entryID: Scalars['ID']['input']
}

export type MutationDeletePatientTagArgs = {
  id: Scalars['ID']['input']
}

export type MutationEditChatMessageArgs = {
  messageIDHash: Scalars['ID']['input']
  text: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationFinancialEligibilityLookupArgs = {
  birthDate?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  groupNumber?: InputMaybe<Scalars['String']['input']>
  lastname: Scalars['String']['input']
  memberID?: InputMaybe<Scalars['String']['input']>
  source: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationFindOrCreateAdvancedChatArgs = {
  role: Scalars['String']['input']
}

export type MutationHideCommunityPostReplyArgs = {
  replyID: Scalars['ID']['input']
}

export type MutationInAppProfileFormUpdateArgs = {
  field: InAppProfileFormFieldInput
}

export type MutationLoginArgs = {
  idToken: Scalars['String']['input']
}

export type MutationMarkChatMessagesAsSeenArgs = {
  advancedChatID?: InputMaybe<Scalars['ID']['input']>
}

export type MutationMarkFeatureSeenArgs = {
  featureID: Scalars['String']['input']
}

export type MutationMarkFeedSeenArgs = {
  uid: Scalars['ID']['input']
}

export type MutationMarkFeedUnreadFromArgs = {
  from: Scalars['DateTime']['input']
  uid: Scalars['ID']['input']
}

export type MutationRegisterOnboardingPatientArgs = {
  input: OnboardingRegistrationInput
}

export type MutationRegisterParticipantArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>
  form: ParticipantRegistrationFormInput
  source?: InputMaybe<Scalars['String']['input']>
}

export type MutationRemoveFavoriteLessonArgs = {
  favoriteID: Scalars['ID']['input']
}

export type MutationRemoveQuestionnaireAssignmentArgs = {
  assignmentID: Scalars['ID']['input']
  uid: Scalars['ID']['input']
}

export type MutationRemoveTagFromPatientArgs = {
  tagID: Scalars['ID']['input']
  uid: Scalars['ID']['input']
}

export type MutationReplyToCommunityPostArgs = {
  postID: Scalars['ID']['input']
  reply: CommunityPostReplyInput
}

export type MutationRescheduleInProgramCallByCoachArgs = {
  callID: Scalars['String']['input']
  start: Scalars['DateTime']['input']
}

export type MutationRescheduleIntakeCallArgs = {
  calendarOwnerEmail: Scalars['String']['input']
  start: Scalars['DateTime']['input']
  uid: Scalars['ID']['input']
}

export type MutationRescheduleVideoCallByParticipantArgs = {
  callID: Scalars['String']['input']
}

export type MutationRestartIntakeArgs = {
  uid: Scalars['ID']['input']
}

export type MutationRestartPatientInProgramArgs = {
  description: Scalars['String']['input']
  programStartDate: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationRetainAdvancedChatFilesArgs = {
  fileIDs: Array<Scalars['ID']['input']>
  messageID: Scalars['ID']['input']
  uid: Scalars['ID']['input']
}

export type MutationRetryLabOrderArgs = {
  orderID: Scalars['ID']['input']
}

export type MutationSavePushNotificationTokenArgs = {
  devicePlatform: DevicePlatform
  token: Scalars['String']['input']
}

export type MutationScheduleVideoCallByCareCoordinatorArgs = {
  callInput: ScheduleVideoCallByCareCoordinatorInput
  uid: Scalars['ID']['input']
}

export type MutationScheduleVideoCallByCoachArgs = {
  callDetails: ScheduleVideoCallInput
}

export type MutationScheduleVideoCallByExternalManagerArgs = {
  callInput: ScheduleVideoCallByExternalManagerInput
  uid: Scalars['ID']['input']
}

export type MutationScheduleVideoCallByParticipantArgs = {
  callInput: ScheduleVideoCallByParticipantInput
}

export type MutationSendEmailsArgs = {
  emailTemplateInput: EmailTemplateInput
  uids: Array<Scalars['ID']['input']>
}

export type MutationSendParticipantBackToCallSchedulingArgs = {
  description: Scalars['String']['input']
  programID: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationSetCallExceptionArgs = {
  callException?: InputMaybe<VideoCallException>
  callID: Scalars['String']['input']
}

export type MutationSetCareteamArgs = {
  coachIDs: Array<Scalars['ID']['input']>
  primaryCoachID: Scalars['ID']['input']
  uid: Scalars['ID']['input']
}

export type MutationSetFeatureFlagOverrideArgs = {
  enabled: Scalars['Boolean']['input']
  key: Scalars['String']['input']
}

export type MutationSetInProgramCallBookingEnabledArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  uid: Scalars['ID']['input']
}

export type MutationSetModuleGoalArgs = {
  input: SetModuleGoalInput
}

export type MutationSetPatientAcceptedArgs = {
  orderLabWork?: InputMaybe<Scalars['Boolean']['input']>
  programStartDate: Scalars['String']['input']
  shipHRVDeviceToPatient?: InputMaybe<Scalars['Boolean']['input']>
  source: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationSetPatientDeclinedV2Args = {
  description?: InputMaybe<Scalars['String']['input']>
  reasons: Array<PatientDeclinedReasonV2>
  uid: Scalars['ID']['input']
}

export type MutationSetPatientProgramEndArgs = {
  engagement: EngagementType
  followUpProgramID?: InputMaybe<Scalars['String']['input']>
  newCareteam?: InputMaybe<NewCareteamInput>
  programEndMetrics?: InputMaybe<ProgramEndMetricsInput>
  uid: Scalars['ID']['input']
}

export type MutationSetSelfCareReminderArgs = {
  pushPermissionStatus: PushNotificationPermissionStatus
  timeOfDay: Scalars['String']['input']
}

export type MutationShiftPatientProgramStartDateArgs = {
  days: Scalars['Int']['input']
  isPostProgram: Scalars['Boolean']['input']
  uid: Scalars['ID']['input']
}

export type MutationStoreMeditationDurationArgs = {
  meditationSeconds: Scalars['Float']['input']
  responseID: Scalars['ID']['input']
}

export type MutationStorePatientResponseArgs = {
  category?: InputMaybe<Scalars['String']['input']>
  clientTime: Scalars['String']['input']
  duration?: InputMaybe<Scalars['Int']['input']>
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>
  lessonID: Scalars['String']['input']
  responseID: Scalars['ID']['input']
  sections?: InputMaybe<Array<PatientResponseSectionInput>>
  sentAt: Scalars['DateTime']['input']
  taskID?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export type MutationStorePaymentMethodArgs = {
  input: StorePaymentMethodInput
}

export type MutationSubmitCallNotesArgs = {
  callID: Scalars['ID']['input']
  notes: Scalars['String']['input']
}

export type MutationTrackAppOpenArgs = {
  appVersion: Scalars['String']['input']
  deviceID: Scalars['String']['input']
  deviceModel: Scalars['String']['input']
  devicePlatform: DevicePlatform
  osVersion: Scalars['String']['input']
  timezone: Scalars['String']['input']
}

export type MutationTrackAppUsageSessionsArgs = {
  sessions: Array<AppUsageSessionInput>
}

export type MutationTrackPushNotificationOpenArgs = {
  customerIO?: InputMaybe<CustomerIoNotificationOpenInput>
}

export type MutationTrackPushNotificationPermissionStatusArgs = {
  permissionStatus: PushNotificationPermissionStatus
}

export type MutationUnhideCommunityPostReplyArgs = {
  replyID: Scalars['ID']['input']
}

export type MutationUpdateAbTestAssignmentsArgs = {
  abTests: Array<AbTestInput>
  uid: Scalars['ID']['input']
}

export type MutationUpdateCallNotesArgs = {
  callID: Scalars['ID']['input']
  notes: Scalars['String']['input']
}

export type MutationUpdateCoachEmailArgs = {
  coachID: Scalars['ID']['input']
  email: Scalars['String']['input']
}

export type MutationUpdateLanguageArgs = {
  language: Scalars['String']['input']
}

export type MutationUpdateOnboardingPatientArgs = {
  input: UpdateOnboardingPatientInput
}

export type MutationUpdatePatientArgs = {
  details?: InputMaybe<PatientDetailsInput>
  patient?: InputMaybe<PatientInput>
  privateUserData?: InputMaybe<PrivateUserDataInput>
  uid: Scalars['ID']['input']
}

export type MutationUpdatePatientByExternalManagerArgs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>
  firstname: Scalars['String']['input']
  lastname: Scalars['String']['input']
  memberID?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>
  referralName: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationUpdatePatientFileArgs = {
  fileID: Scalars['ID']['input']
  input: UpdatePatientFileInput
}

export type MutationUpdatePatientIntegrationsArgs = {
  input: PatientIntegrationsInput
  uid: Scalars['ID']['input']
}

export type MutationUpdatePatientProgramArgs = {
  programPath?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdatePatientProgramStartDateArgs = {
  isPostProgram: Scalars['Boolean']['input']
  programStartDate: Scalars['Date']['input']
  uid: Scalars['ID']['input']
}

export type MutationUpdatePatientQuickNoteArgs = {
  quickNote: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationUpdateProgramStartDateArgs = {
  programStartDate: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type MutationUpdateSourceAndStateOfResidenceArgs = {
  input: UpdateSourceAndStateOfResidenceInput
}

export type NewCareteamInput = {
  coachIDs: Array<Scalars['ID']['input']>
  primaryCoachID: Scalars['ID']['input']
}

export type OnboardingPatient = {
  __typename?: 'OnboardingPatient'
  birthDate?: Maybe<Scalars['Date']['output']>
  credentialingHealthPlan?: Maybe<Scalars['String']['output']>
  details?: Maybe<OnboardingPatientDetails>
  email: Scalars['EmailAddress']['output']
  firstname?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  intakeCall?: Maybe<VideoCall>
  lastname?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  stateOfResidence?: Maybe<Scalars['String']['output']>
}

export type OnboardingPatientDetails = {
  __typename?: 'OnboardingPatientDetails'
  groupID?: Maybe<Scalars['String']['output']>
  insuranceSubscriber?: Maybe<InsuranceSubscriber>
  isDependent?: Maybe<Scalars['Boolean']['output']>
  memberID?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
}

export type OnboardingRegistrationInput = {
  acceptedConsentIDs?: InputMaybe<Array<Scalars['String']['input']>>
  uid?: InputMaybe<Scalars['ID']['input']>
}

export type OpenScheduleVideoCallLesson = {
  __typename?: 'OpenScheduleVideoCallLesson'
  lessonID?: Maybe<Scalars['String']['output']>
  taskID?: Maybe<Scalars['String']['output']>
}

export type OverdueQuestionnaire = {
  __typename?: 'OverdueQuestionnaire'
  createdAt: Scalars['DateTime']['output']
  itemID: Scalars['ID']['output']
  lessonID: Scalars['String']['output']
  weekNbr: Scalars['Int']['output']
}

export type ParticipantProfile = {
  __typename?: 'ParticipantProfile'
  autoOpeningLesson?: Maybe<AutoOpeningLesson>
  chatMessagingEnabled: Scalars['Boolean']['output']
  enabledTabs: InAppEnabledTabs
  /** False when the client should render the orientation home layout (theme illustration, favorites hidden, no Today section). Flips to true once the participant's program has started. */
  hasProgramStarted: Scalars['Boolean']['output']
  /** True for non-Kaiser patients on master_v5 or master_v5_self_pay. The client uses this to render an 'Explore more' section, swap in the orientation home layout, and hide favorites. */
  hasWeekZeroRemoved: Scalars['Boolean']['output']
  /** Whether Spanish i18n features are available to the patient. Pass credentialingHealthPlan to evaluate a plan the patient is about to switch to. */
  i18nEnabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  /** True when the patient is in the abTestDailyPractices variant. The client uses this to show the redesigned daily practices: the post-completion reminder and celebration, the Self-Care Reminder in notification settings and the Progress link to keep practicing. */
  isAbTestDailyPracticesVariant: Scalars['Boolean']['output']
  /** True when the patient is in the abTestFtux variant. The client uses this to render the new first-time user experience (Home, Timeline, Progress and Therapist screens). */
  isAbTestFtuxVariant: Scalars['Boolean']['output']
  /**
   * True when the patient is in the abTestProgressTab variant. The client uses this to render the Progress tab in the bottom navigation bar.
   * @deprecated Use enabledTabs.progress instead.
   */
  isAbTestProgressTabVariant: Scalars['Boolean']['output']
  /**
   * True when the patient is in the abTestWeekZeroRemoval variant. The client uses this to render an 'Explore more' section, swap in the orientation home layout, and hide favorites.
   * @deprecated Use hasWeekZeroRemoved instead. PX-3668
   */
  isAbTestVariant: Scalars['Boolean']['output']
  language: Scalars['String']['output']
  paymentMethods?: Maybe<Array<PaymentMethod>>
  productInfo?: Maybe<ProductInfo>
  program: Program
  registrationComplete: Scalars['Boolean']['output']
  shouldShowTeenRestriction: Scalars['Boolean']['output']
  showProfileFabNotification: Scalars['Boolean']['output']
  source?: Maybe<Scalars['String']['output']>
  /** @deprecated supportURL was moved to supportSection in InAppAccountAndSettingsScreen. */
  supportURL?: Maybe<Scalars['String']['output']>
  /** @deprecated Is not used by a new app version. */
  tabIntroduction?: Maybe<InAppTabIntroduction>
}

export type ParticipantProfileI18nEnabledArgs = {
  credentialingHealthPlan?: InputMaybe<Scalars['String']['input']>
}

export type ParticipantRegistered = {
  __typename?: 'ParticipantRegistered'
  email?: Maybe<Scalars['String']['output']>
}

export type ParticipantRegistrationFailed = {
  __typename?: 'ParticipantRegistrationFailed'
  reason: ParticipantRegistrationFailedReason
}

export enum ParticipantRegistrationFailedReason {
  WrongAccessCode = 'WRONG_ACCESS_CODE',
}

export type ParticipantRegistrationFormInput = {
  acceptedConsentIDs: Array<Scalars['String']['input']>
  customQuestions?: InputMaybe<Array<CustomQuestionInput>>
  dateOfBirth: Scalars['Date']['input']
  employer?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  insuranceGroupID?: InputMaybe<Scalars['String']['input']>
  insuranceMemberID?: InputMaybe<Scalars['String']['input']>
  insuranceSubscriberOfDependent?: InputMaybe<InsuranceSubscriberOfDependentInput>
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
  referralName?: InputMaybe<Scalars['String']['input']>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
}

export type ParticipantRegistrationResult = ParticipantRegistered | ParticipantRegistrationFailed

export type Patient = {
  __typename?: 'Patient'
  abTests?: Maybe<Array<AbTest>>
  billingID?: Maybe<Scalars['String']['output']>
  birthDate?: Maybe<Scalars['Date']['output']>
  careTeam?: Maybe<Array<CareTeamMember>>
  chatMessagingEnabled?: Maybe<Scalars['Boolean']['output']>
  costEstimateFailure?: Maybe<PatientCostEstimateFailure>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  credentialingHealthPlan?: Maybe<Scalars['String']['output']>
  details?: Maybe<Scalars['JSONObject']['output']>
  earliestProgramStartDate?: Maybe<Scalars['String']['output']>
  earliestRestartProgramStartDate: Scalars['String']['output']
  educationLevel?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['EmailAddress']['output']>
  emergencyContact?: Maybe<EmergencyContact>
  enrollment: Enrollment
  financialEligibilityCheck?: Maybe<PatientFinancialEligibilityCheck>
  firstname?: Maybe<Scalars['String']['output']>
  genderIdentity?: Maybe<Scalars['String']['output']>
  /** True for non-Kaiser patients on master_v5 or master_v5_self_pay. The dashboard uses this to let coaches schedule a program start from tomorrow (any weekday) instead of being restricted to the next Monday. */
  hasWeekZeroRemoved: Scalars['Boolean']['output']
  inProgramVideoCallBookingInformation?: Maybe<InProgramVideoCallBookingInformation>
  indicators?: Maybe<PatientIndicators>
  intakeCallTime?: Maybe<Scalars['DateTime']['output']>
  /**
   * True when the patient is in the abTestWeekZeroRemoval variant. The dashboard uses this to let coaches schedule a program start from tomorrow (any weekday) instead of being restricted to the next Monday.
   * @deprecated Use hasWeekZeroRemoved instead. PX-3668
   */
  isAbTestWeekZeroRemovalVariant: Scalars['Boolean']['output']
  junctionID?: Maybe<Scalars['String']['output']>
  language?: Maybe<Scalars['String']['output']>
  lastStateTransitionAt?: Maybe<Scalars['DateTime']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  medicalReport?: Maybe<MedicalReport>
  occupation?: Maybe<Scalars['String']['output']>
  otherEducation?: Maybe<Scalars['String']['output']>
  otherRacialIdentity?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  preferredName?: Maybe<Scalars['String']['output']>
  primaryCareProvider?: Maybe<PrimaryCareProvider>
  privateUserData: PrivateUserData
  program?: Maybe<Program>
  progressTracker?: Maybe<ProgressTracker>
  quickNote?: Maybe<Scalars['String']['output']>
  racialIdentities?: Maybe<Array<Scalars['String']['output']>>
  shippingAddress?: Maybe<Address>
  state?: Maybe<PatientState>
  stateOfResidence?: Maybe<Scalars['String']['output']>
  tags?: Maybe<Array<PatientTag>>
  timezone?: Maybe<Scalars['String']['output']>
  uid: Scalars['ID']['output']
  videoCallBookingInformation?: Maybe<VideoCallBookingInformation>
}

export type PatientAnswerData = {
  __typename?: 'PatientAnswerData'
  address?: Maybe<Scalars['String']['output']>
  alcohol?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  currentLivingSituation?: Maybe<Scalars['String']['output']>
  detailsOfExperienceWithMentalHealthProfessional?: Maybe<Scalars['String']['output']>
  detailsOfHospitalization?: Maybe<Scalars['String']['output']>
  doctorName?: Maybe<Scalars['String']['output']>
  doctorPhoneNumber?: Maybe<Scalars['String']['output']>
  emergencyContactName?: Maybe<Scalars['String']['output']>
  emergencyContactPhoneNumber?: Maybe<Scalars['String']['output']>
  functionalImpairments?: Maybe<Array<Scalars['String']['output']>>
  genderIdentity?: Maybe<Scalars['String']['output']>
  hasAllergies?: Maybe<Scalars['Boolean']['output']>
  hasBeenHospitalized?: Maybe<Scalars['Boolean']['output']>
  hasSeenAMentalHealthProfessional?: Maybe<Scalars['Boolean']['output']>
  highestLevelOfEducationCompleted?: Maybe<Scalars['String']['output']>
  listAllergies?: Maybe<Scalars['String']['output']>
  mainReasonForSeekingSupport?: Maybe<Scalars['String']['output']>
  marijuana?: Maybe<Scalars['String']['output']>
  maritalStatus?: Maybe<Scalars['String']['output']>
  medicalHistory?: Maybe<Array<Scalars['String']['output']>>
  medications?: Maybe<Array<PatientAnswerMedication>>
  mentalIllnessDiagnosisFamily?: Maybe<Array<Scalars['String']['output']>>
  mentalIllnessHistoryInFamily?: Maybe<Scalars['Boolean']['output']>
  nonprescriptionDrugs?: Maybe<Scalars['String']['output']>
  occupation?: Maybe<Scalars['String']['output']>
  otherConditions?: Maybe<Scalars['String']['output']>
  otherEducationCompleted?: Maybe<Scalars['String']['output']>
  otherRacialIdentity?: Maybe<Scalars['String']['output']>
  otherRecreationalSubstances?: Maybe<Scalars['String']['output']>
  preferredName?: Maybe<Scalars['String']['output']>
  racialIdentity?: Maybe<Array<Scalars['String']['output']>>
  state?: Maybe<Scalars['String']['output']>
  substanceUseSupport?: Maybe<Array<Scalars['String']['output']>>
  supportDetails?: Maybe<Scalars['String']['output']>
  takesMedication?: Maybe<Scalars['Boolean']['output']>
  tobaccoCigarettesChewVape?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type PatientAnswerMedication = {
  __typename?: 'PatientAnswerMedication'
  dosage?: Maybe<Scalars['String']['output']>
  frequency?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type PatientCompletedResponsesIndicator = {
  __typename?: 'PatientCompletedResponsesIndicator'
  count: Scalars['Int']['output']
  date: Scalars['Date']['output']
}

export type PatientCostEstimateFailure = {
  __typename?: 'PatientCostEstimateFailure'
  createdAt: Scalars['DateTime']['output']
  reason: Scalars['String']['output']
}

export enum PatientDeclinedReasonV2 {
  ClinicalHighAcuity = 'CLINICAL_HIGH_ACUITY',
  ClinicalLowAcuity = 'CLINICAL_LOW_ACUITY',
  ClinicalOther = 'CLINICAL_OTHER',
  OperationalDuplicateAccount = 'OPERATIONAL_DUPLICATE_ACCOUNT',
  OperationalInsuranceCostShareTooHigh = 'OPERATIONAL_INSURANCE_COST_SHARE_TOO_HIGH',
  OperationalInsuranceMedicaidOrMedicare = 'OPERATIONAL_INSURANCE_MEDICAID_OR_MEDICARE',
  OperationalInsuranceOutOfNetwork = 'OPERATIONAL_INSURANCE_OUT_OF_NETWORK',
  OperationalNoProvidersWithRequiredCredentialing = 'OPERATIONAL_NO_PROVIDERS_WITH_REQUIRED_CREDENTIALING',
  OperationalOutsideGeographicCoverage = 'OPERATIONAL_OUTSIDE_GEOGRAPHIC_COVERAGE',
  OperationalSwitchedOrLostInsurance = 'OPERATIONAL_SWITCHED_OR_LOST_INSURANCE',
  OperationalTechnicalIssue = 'OPERATIONAL_TECHNICAL_ISSUE',
  OperationalUnder_18 = 'OPERATIONAL_UNDER_18',
  PersonalFeelsBetter = 'PERSONAL_FEELS_BETTER',
  PersonalFoundAlternativeCare = 'PERSONAL_FOUND_ALTERNATIVE_CARE',
  PersonalFrequentTravel = 'PERSONAL_FREQUENT_TRAVEL',
  PersonalLifeEvent = 'PERSONAL_LIFE_EVENT',
  PersonalNotInterested = 'PERSONAL_NOT_INTERESTED',
  PersonalNotResponding = 'PERSONAL_NOT_RESPONDING',
  PersonalOther = 'PERSONAL_OTHER',
  PersonalPrefersOtherLanguage = 'PERSONAL_PREFERS_OTHER_LANGUAGE',
  PersonalPrefersTraditionalOneToOneTherapy = 'PERSONAL_PREFERS_TRADITIONAL_ONE_TO_ONE_THERAPY',
  PersonalTimeCommitment = 'PERSONAL_TIME_COMMITMENT',
}

export type PatientDetailsInput = {
  employer?: InputMaybe<Scalars['String']['input']>
  excludedFromCalculations?: InputMaybe<Scalars['Boolean']['input']>
  externalReferenceID?: InputMaybe<Scalars['String']['input']>
  insuranceGroupID?: InputMaybe<Scalars['String']['input']>
  insuranceMemberID?: InputMaybe<Scalars['String']['input']>
  isDependent?: InputMaybe<Scalars['Boolean']['input']>
  referralName?: InputMaybe<Scalars['String']['input']>
  referralType?: InputMaybe<Scalars['String']['input']>
  registrationSource?: InputMaybe<Scalars['String']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type PatientEngagementIndicator = {
  __typename?: 'PatientEngagementIndicator'
  completedIntros: Scalars['Int']['output']
  totalPossibleIntros: Scalars['Int']['output']
  type: EngagementType
}

export type PatientFile = {
  __typename?: 'PatientFile'
  contentType: Scalars['String']['output']
  downloadURL?: Maybe<Scalars['String']['output']>
  fileID: Scalars['ID']['output']
  filename: Scalars['String']['output']
  objectKey: Scalars['String']['output']
  size: Scalars['Int']['output']
  uploadedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PatientFinancialEligibilityCheck = {
  __typename?: 'PatientFinancialEligibilityCheck'
  aperoEligibilityID: Scalars['String']['output']
  coverageActive: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  subscriber: PatientFinancialEligibilityCheckSubscriber
  warnings?: Maybe<Array<Scalars['String']['output']>>
}

export type PatientFinancialEligibilityCheckSubscriber = {
  __typename?: 'PatientFinancialEligibilityCheckSubscriber'
  birthDate?: Maybe<Scalars['Date']['output']>
  firstName: Scalars['String']['output']
  groupDescription?: Maybe<Scalars['String']['output']>
  groupNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type PatientHistory = {
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  date?: Maybe<Scalars['String']['output']>
  entryID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<PatientHistoryType>
}

export enum PatientHistoryOrderByInput {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
}

export type PatientHistoryPrefillData = {
  __typename?: 'PatientHistoryPrefillData'
  value: Scalars['JSONObject']['output']
}

export type PatientHistoryReferencesInput = {
  callID?: InputMaybe<Scalars['ID']['input']>
}

export enum PatientHistoryType {
  Accepted = 'ACCEPTED',
  AdvancedFollowUpNote = 'ADVANCED_FOLLOW_UP_NOTE',
  AnonymousNote = 'ANONYMOUS_NOTE',
  Asrm = 'ASRM',
  Brs = 'BRS',
  Burnout = 'BURNOUT',
  CheckInCall = 'CHECK_IN_CALL',
  Custom = 'CUSTOM',
  Declined = 'DECLINED',
  DischargeSummaryNote = 'DISCHARGE_SUMMARY_NOTE',
  FinancialEligibilityConfirmed = 'FINANCIAL_ELIGIBILITY_CONFIRMED',
  Gad7 = 'GAD7',
  IntakeNote = 'INTAKE_NOTE',
  IntakeNoteCoaching = 'INTAKE_NOTE_COACHING',
  IntakeNoteComprehensive = 'INTAKE_NOTE_COMPREHENSIVE',
  IntakeNotePsychiatry = 'INTAKE_NOTE_PSYCHIATRY',
  Isi = 'ISI',
  LabOrder = 'LAB_ORDER',
  LabOrderNote = 'LAB_ORDER_NOTE',
  MissedIntakeCall = 'MISSED_INTAKE_CALL',
  MonthlySummaryNote = 'MONTHLY_SUMMARY_NOTE',
  Note = 'NOTE',
  Ocir = 'OCIR',
  ParticipantReEnrolled = 'PARTICIPANT_RE_ENROLLED',
  Pcl5 = 'PCL5',
  PhoneCall = 'PHONE_CALL',
  Phq9 = 'PHQ9',
  ProgramEnd = 'PROGRAM_END',
  Pss4 = 'PSS4',
  Sms = 'SMS',
  TreatmentPlan = 'TREATMENT_PLAN',
  TreatmentPlanComprehensive = 'TREATMENT_PLAN_COMPREHENSIVE',
  TreatmentPlanComprehensiveUpdate = 'TREATMENT_PLAN_COMPREHENSIVE_UPDATE',
  VideoCall = 'VIDEO_CALL',
  Who5 = 'WHO5',
  Wpai = 'WPAI',
}

export type PatientIndicators = {
  __typename?: 'PatientIndicators'
  /** Unseen patient messages in the Advanced role chats the signed-in coach holds. Excluded from newMessages. */
  advancedRoleChatNewMessages?: Maybe<PatientNewMessageIndicator>
  completedCallAwaitingNote?: Maybe<VideoCall>
  completedResponses?: Maybe<Array<PatientCompletedResponsesIndicator>>
  currentOrUpcomingCall?: Maybe<VideoCall>
  daysDisengaged?: Maybe<DaysDisengagedIndicator>
  engagement?: Maybe<PatientEngagementIndicator>
  financialEligibilityConfirmed?: Maybe<Scalars['Boolean']['output']>
  /** When the authenticated coach last viewed this participant's feed. Null if never viewed. */
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>
  /** The most recent lab order whose results came back with a note in the participant's history. Null if none. */
  latestReturnedLabOrderID?: Maybe<Scalars['ID']['output']>
  monthlySummaryNotes?: Maybe<MonthlySummaryNoteIndicator>
  newMessages?: Maybe<PatientNewMessageIndicator>
  overdueHealthQuestionnaire?: Maybe<Scalars['Boolean']['output']>
  /** Null when the participant's latest PHQ-9 question 9 answer is 0 or they have no PHQ-9 entries. */
  risk?: Maybe<RiskIndicator>
  /** @deprecated Use risk instead. PX-3677 */
  suicidal?: Maybe<Scalars['Boolean']['output']>
}

export type PatientIndicatorsCompletedResponsesArgs = {
  endDate: Scalars['Date']['input']
  startDate: Scalars['Date']['input']
}

export type PatientInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>
  educationLevel?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['EmailAddress']['input']>
  emergencyContact?: InputMaybe<EmergencyContactInput>
  firstname?: InputMaybe<Scalars['String']['input']>
  genderIdentity?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  maritalStatus?: InputMaybe<Scalars['String']['input']>
  occupation?: InputMaybe<Scalars['String']['input']>
  otherEducation?: InputMaybe<Scalars['String']['input']>
  otherRacialIdentity?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  racialIdentities?: InputMaybe<Array<Scalars['String']['input']>>
  shippingAddress?: InputMaybe<AddressInput>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
}

export type PatientIntegrationsInput = {
  /**
   * Junction ID can be provided to link the patient to a Junction user.
   * If provided, the Junction user must exist and the patient must not already be linked to a different Junction user.
   * If null, the patient will be unlinked from Junction.
   * If undefined, the patient will not be updated.
   */
  junctionID?: InputMaybe<Scalars['String']['input']>
}

export type PatientNewMessageIndicator = {
  __typename?: 'PatientNewMessageIndicator'
  count: Scalars['Int']['output']
}

export enum PatientProgramWeek {
  Week_0 = 'WEEK_0',
  Week_1 = 'WEEK_1',
  Week_2 = 'WEEK_2',
  Week_3 = 'WEEK_3',
  Week_4 = 'WEEK_4',
  Week_5 = 'WEEK_5',
  Week_6 = 'WEEK_6',
  Week_7 = 'WEEK_7',
  Week_8 = 'WEEK_8',
  Week_9 = 'WEEK_9',
  Week_10 = 'WEEK_10',
  Week_11 = 'WEEK_11',
  Week_12 = 'WEEK_12',
  Week_12Plus = 'WEEK_12_PLUS',
}

export type PatientResponse = {
  __typename?: 'PatientResponse'
  category?: Maybe<Scalars['String']['output']>
  clientTime: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  duration?: Maybe<Scalars['Int']['output']>
  groupID?: Maybe<Scalars['String']['output']>
  isCompleted: Scalars['Boolean']['output']
  lessonID: Scalars['String']['output']
  meditationSeconds?: Maybe<Scalars['Float']['output']>
  programID: Scalars['String']['output']
  responseID: Scalars['ID']['output']
  sections: Array<PatientResponseSection>
  sentAt: Scalars['DateTime']['output']
  taskID?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  uid: Scalars['ID']['output']
  weekNbr?: Maybe<Scalars['Int']['output']>
}

export type PatientResponseSectionsArgs = {
  groupSections?: InputMaybe<Scalars['Boolean']['input']>
}

export type PatientResponseSection = {
  __typename?: 'PatientResponseSection'
  description?: Maybe<Scalars['String']['output']>
  entries: Array<PatientResponseSectionEntry>
  isSharedWithGroup: Scalars['Boolean']['output']
  position: Scalars['Int']['output']
  responseID: Scalars['ID']['output']
  sectionID: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  useContextFrom?: Maybe<Scalars['String']['output']>
}

export type PatientResponseSectionEntry = {
  __typename?: 'PatientResponseSectionEntry'
  entryContext?: Maybe<PatientResponseSectionEntryContext>
  entryID: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  position: Scalars['Int']['output']
  question?: Maybe<Scalars['String']['output']>
  rawValue?: Maybe<Scalars['JSON']['output']>
  tag?: Maybe<Scalars['String']['output']>
}

export type PatientResponseSectionEntryContext = PatientResponseSectionEntryContextSingleChoice

export type PatientResponseSectionEntryContextInput = {
  inputSingleChoice?: InputMaybe<PatientResponseSectionEntryContextSingleChoiceInput>
}

export type PatientResponseSectionEntryContextSingleChoice = {
  __typename?: 'PatientResponseSectionEntryContextSingleChoice'
  options: Array<PatientResponseSectionEntryContextSingleChoiceOption>
}

export type PatientResponseSectionEntryContextSingleChoiceInput = {
  options: Array<PatientResponseSectionEntryContextSingleChoiceOptionInput>
}

export type PatientResponseSectionEntryContextSingleChoiceOption = {
  __typename?: 'PatientResponseSectionEntryContextSingleChoiceOption'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type PatientResponseSectionEntryContextSingleChoiceOptionInput = {
  label: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type PatientResponseSectionEntryInput = {
  context?: InputMaybe<PatientResponseSectionEntryContextInput>
  entryID: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  position: Scalars['Int']['input']
  profileVariableKey?: InputMaybe<Scalars['String']['input']>
  question?: InputMaybe<Scalars['String']['input']>
  rawValue?: InputMaybe<Scalars['JSON']['input']>
  tag?: InputMaybe<Scalars['String']['input']>
}

export type PatientResponseSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>
  entries?: InputMaybe<Array<PatientResponseSectionEntryInput>>
  position: Scalars['Int']['input']
  sectionID: Scalars['ID']['input']
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  useContextFrom?: InputMaybe<Scalars['String']['input']>
}

export enum PatientSortField {
  CallScheduledAt = 'CALL_SCHEDULED_AT',
  CreatedAt = 'CREATED_AT',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  LastStateTransitionAt = 'LAST_STATE_TRANSITION_AT',
}

export enum PatientSortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum PatientState {
  DidNotStart = 'DID_NOT_START',
  /** @deprecated Use INTAKE_REGISTERED, INTAKE_LOGGED_IN, INTAKE_CALL_SCHEDULED instead */
  Intake = 'INTAKE',
  IntakeCallScheduled = 'INTAKE_CALL_SCHEDULED',
  IntakeLoggedIn = 'INTAKE_LOGGED_IN',
  IntakePreRegistered = 'INTAKE_PRE_REGISTERED',
  IntakeRegistered = 'INTAKE_REGISTERED',
  PostProgram = 'POST_PROGRAM',
  Test = 'TEST',
  Treatment = 'TREATMENT',
}

export type PatientTag = {
  __typename?: 'PatientTag'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type PaymentMethod = PaymentMethodCreditCard

export type PaymentMethodCreditCard = {
  __typename?: 'PaymentMethodCreditCard'
  isValid: Scalars['Boolean']['output']
}

export enum PaymentMethodStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
}

export type PaymentSummary = {
  __typename?: 'PaymentSummary'
  amountCopy?: Maybe<Scalars['String']['output']>
  badgeCopy?: Maybe<Scalars['String']['output']>
  billingDescription?: Maybe<Scalars['String']['output']>
  conditions?: Maybe<Array<InAppCostEstimateComponent>>
  intervalCopy?: Maybe<Scalars['String']['output']>
}

export type Phq9Series = AssessmentGraphSeries & {
  __typename?: 'Phq9Series'
  measure: AssessmentMeasure
  points: Array<AssessmentGraphPoint>
}

export type PracticeDay = {
  __typename?: 'PracticeDay'
  completedLesson: Scalars['Boolean']['output']
  date: Scalars['Date']['output']
  isToday: Scalars['Boolean']['output']
}

export enum PracticeGoal {
  Daily = 'DAILY',
  FiveDay = 'FIVE_DAY',
  ThreeDay = 'THREE_DAY',
}

export type PrefilledIntakeNote = {
  __typename?: 'PrefilledIntakeNote'
  EMPLOYMENT?: Maybe<IntakeNoteEmployment>
  HEALTH_HISTORY?: Maybe<IntakeNoteHealthHistory>
  OBSTACLES?: Maybe<Scalars['String']['output']>
}

export type PrimaryCareProvider = {
  __typename?: 'PrimaryCareProvider'
  address?: Maybe<Scalars['String']['output']>
  clinicName?: Maybe<Scalars['String']['output']>
  consentGivenAt?: Maybe<Scalars['DateTime']['output']>
  hasPrimaryCareProvider?: Maybe<Scalars['Boolean']['output']>
  phone?: Maybe<Scalars['String']['output']>
  physicianName?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export type PrivateUserData = {
  __typename?: 'PrivateUserData'
  consentDocuments: Array<ConsentDocument>
  firstTimeLoginAt?: Maybe<Scalars['DateTime']['output']>
  groupID?: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  isFreeRider: Scalars['Boolean']['output']
  programID?: Maybe<Scalars['ID']['output']>
  programStartDate?: Maybe<Scalars['DateTime']['output']>
  timezone?: Maybe<Scalars['String']['output']>
  variables?: Maybe<PrivateUserDataVariables>
}

export type PrivateUserDataInput = {
  isFreeRider?: InputMaybe<Scalars['Boolean']['input']>
}

export type PrivateUserDataVariables = {
  __typename?: 'PrivateUserDataVariables'
  hrvDevice?: Maybe<Scalars['String']['output']>
}

export type ProductInfo = {
  __typename?: 'ProductInfo'
  billingCopy?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'weeklyPriceDiscountLabel' field instead */
  discountLabelCopy?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'weeklyPriceDiscountCopy' field instead */
  discountPriceCopy?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** @deprecated Use 'weeklyPriceCopy' field instead. */
  priceCopy: Scalars['String']['output']
  /** @deprecated Not in use anymore */
  promotionalPriceCopy?: Maybe<Scalars['String']['output']>
  /** @deprecated Not in use anymore, your application logic should handle this */
  promotionalPriceIntervalCopy?: Maybe<Scalars['String']['output']>
  weeklyPriceCents: Scalars['Int']['output']
  weeklyPriceCopy: Scalars['String']['output']
  weeklyPriceDiscountCopy?: Maybe<Scalars['String']['output']>
  weeklyPriceDiscountLabel?: Maybe<Scalars['String']['output']>
  weeklyPriceDiscoutCents?: Maybe<Scalars['Int']['output']>
}

export type Program = {
  __typename?: 'Program'
  acceptanceCriteria?: Maybe<Array<Scalars['String']['output']>>
  /** Program lesson modifier: use different intake lesson for Kaiser patients. */
  credentialingHealthPlan?: Maybe<Scalars['String']['output']>
  currentTheme: ProgramTheme
  id: Scalars['ID']['output']
  /** Program lesson modifier: will not return intake call booking lesson cards if value is true. */
  intakeCallScheduled?: Maybe<Scalars['Boolean']['output']>
  /** Language for lesson content translation. */
  language?: Maybe<Scalars['String']['output']>
  lastWeekNbr: Scalars['Int']['output']
  /** URL of the illustration shown on the orientation home layout. */
  orientationIllustrationUrl: Scalars['String']['output']
  patientHistoryTypes?: Maybe<Array<Scalars['String']['output']>>
}

export type ProgramAcceptanceCriteriaArgs = {
  uid: Scalars['ID']['input']
}

export type ProgramPatientHistoryTypesArgs = {
  uid: Scalars['ID']['input']
}

export type ProgramEndMetricInput = {
  baseline: Scalars['Int']['input']
  programEnd?: InputMaybe<Scalars['Int']['input']>
}

export type ProgramEndMetricsInput = {
  GAD7?: InputMaybe<ProgramEndMetricInput>
  PHQ9?: InputMaybe<ProgramEndMetricInput>
  WHO5?: InputMaybe<ProgramEndMetricInput>
}

export type ProgramExperts = {
  __typename?: 'ProgramExperts'
  guides: Array<ProgramGuide>
  /** During intake this is the coach of the latest booked intake call: null until a call is booked, null again if it gets cancelled, and still set after the call has taken place until the patient is accepted to the program. Once the program has started it is the patient's primary coach regardless of calls. */
  primaryCoach?: Maybe<CoachProfile>
}

export type ProgramGuide = {
  __typename?: 'ProgramGuide'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  photoUrl: Scalars['String']['output']
  title: Scalars['String']['output']
  videoTranscript?: Maybe<Scalars['String']['output']>
  videoUrl?: Maybe<Scalars['String']['output']>
  videoUrlSD?: Maybe<Scalars['String']['output']>
}

export type ProgramTheme = {
  __typename?: 'ProgramTheme'
  id: Scalars['ID']['output']
  language?: Maybe<Scalars['String']['output']>
  programID: Scalars['ID']['output']
  themeHeader: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ProgressTracker = {
  __typename?: 'ProgressTracker'
  modules: Array<ProgressTrackerModule>
  /**
   * Total number of modules in the participant's program (e.g. 8 or 12).
   * The current and past modules are returned in `modules`; this lets clients
   * render the remaining (future) modules too.
   */
  totalModules: Scalars['Int']['output']
}

export type ProgressTrackerModule = {
  __typename?: 'ProgressTrackerModule'
  completionRate: Scalars['Float']['output']
  days: Array<PracticeDay>
  goal: ModuleGoal
  moduleNumber: Scalars['Int']['output']
  motivationalMessage: Scalars['String']['output']
  /**
   * Minutes of self-care (app usage) during the module, or null when usage
   * tracking wasn't live for the whole module so the total would be misleading.
   */
  selfCareTimeMinutes?: Maybe<Scalars['Int']['output']>
}

export enum PushNotificationPermissionStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  NotDetermined = 'NOT_DETERMINED',
  NotWanted = 'NOT_WANTED',
  Unknown = 'UNKNOWN',
}

export type Query = {
  __typename?: 'Query'
  accountsForSignup?: Maybe<SignupAccounts>
  additionalSignupQuestions?: Maybe<Array<AdditionalSignupQuestion>>
  /** The signed-in patient's Advanced chats, one per care-team role they have opened. */
  advancedChats: Array<AdvancedChat>
  /** The patient's messages in the Advanced role chats the signed-in coach holds, which the feed leaves out. */
  advancedRoleChatMessages: Array<ChatMessage>
  afterAppLoadScreen?: Maybe<AfterAppLoadScreen>
  appStoreReviewPrompt: AppStoreReviewPromptStatus
  assessmentGraph?: Maybe<AssessmentGraph>
  availableInAppRating?: Maybe<InAppRating>
  availableVideoCallSlots: AvailableVideoCallSlotsResult
  billingContacts: Array<BillingContact>
  callDurationInMinutes: Scalars['Int']['output']
  /** Unset advancedChatID is the shared conversation; a set one is that Advanced chat alone. */
  chatMessages: ChatMessagesResult
  checkAppVersion: CheckAppVersionResult
  coachAvailability: CoachAvailabilityResult
  coachAvailabilityByParticipant: CoachAvailabilityResult
  coachAvailabilityPublic: CoachAvailability
  coachAvailabilityVideoCallSlotsByParticipant: CoachAvailabilityVideoCallSlotsByParticipant
  coachProfile?: Maybe<CoachProfile>
  community?: Maybe<Community>
  /** Single community post */
  communityPost: CommunityPost
  /** Feed of community posts that have been published */
  communityPosts: CommunityPostsResult
  costEstimateLookup: CostEstimateLookup
  emailTemplates: Array<EmailTemplate>
  emails: Array<Email>
  /** Additional lessons surfaced under the 'Explore more' section. Completed non-sticky lessons are filtered out; sticky lessons stay at the end of the list. The abTestFtux variant does not get the app tour and chat lessons. */
  exploreMoreLessons: Array<TaskRecommendation>
  /** App screens linked above the lessons in the 'Explore more' section. Empty outside the abTestFtux variant. */
  exploreMoreShortcuts: Array<ExploreMoreShortcut>
  externalManager?: Maybe<ExternalManager>
  externalOrganizations: Array<ExternalOrganization>
  favoriteLessons: FavoriteLessons
  featureFlags: Array<FeatureFlag>
  feed: FeedResult
  hasSpanishTherapists: Scalars['Boolean']['output']
  inAppAccountAndSettingsScreen?: Maybe<InAppAccountAndSettingsScreen>
  inAppCostEstimate?: Maybe<InAppCostEstimate>
  inAppIntakeHomeScreen?: Maybe<InAppIntakeHomeScreen>
  inAppPaymentInformation?: Maybe<InAppPaymentInformationResult>
  inAppPromptActionPanel?: Maybe<InAppPromptActionPanelResult>
  inAppSignupForm: InAppSignupFormResult
  inAppStripeConfig: InAppStripeConfig
  inAppVideoCall?: Maybe<InAppVideoCallResult>
  intakeNoteComprehensivePatientData: IntakeNoteComprehensivePatientData
  labOrder: LabOrder
  /** Temporary endpoint for fetching the most recently published post */
  lastPublishedCommunityPost?: Maybe<CommunityPost>
  lookupPatientByEmail: LookupPatientByEmailResult
  onboardingPatient: OnboardingPatient
  participantProfile: ParticipantProfile
  patient: Patient
  patientFile: PatientFile
  patientHistory: Array<PatientHistory>
  patientHistoryPrefillData: PatientHistoryPrefillData
  patientQuestionnaireAssignments: Array<QuestionnaireAssignment>
  patientTags: Array<PatientTag>
  patients: Array<Patient>
  postProgramLessons: Array<WeekTheme>
  prefilledIntakeNote: PrefilledIntakeNote
  /** The experts behind the patient's care: their primary coach and the program guides. */
  programExperts: ProgramExperts
  progressTracker: ProgressTracker
  relevantHistory: RelevantHistoryResult
  response?: Maybe<PatientResponse>
  searchPatientsV2: SearchPatientsResponse
  selfCareReminder?: Maybe<SelfCareReminder>
  session?: Maybe<Session>
  sources: Array<Source>
  taskRecommendations: TaskRecommendationsResult
  taskRecommendationsForPatient: TaskRecommendationsResult
  timeline: Array<TimelineWeek>
  /** Feed of unpublished community posts */
  unpublishedCommunityPosts: CommunityPostsResult
  unseenChatMessages: UnseenChatMessages
  /** The patient's program start while it is still ahead. Null outside the abTestFtux variant, before the patient is accepted, once the program has started, or for programs that open with week 0. */
  upcomingProgram?: Maybe<UpcomingProgram>
  videoCallUrl: Scalars['String']['output']
  whatIsIncludedSection?: Maybe<InAppCostEstimateSection>
}

export type QueryAccountsForSignupArgs = {
  filter?: InputMaybe<AccountsFilter>
}

export type QueryAdvancedRoleChatMessagesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>
  before?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<FeedOrder>
  uid: Scalars['ID']['input']
}

export type QueryBillingContactsArgs = {
  billingIDs: Array<Scalars['String']['input']>
}

export type QueryCallDurationInMinutesArgs = {
  uid: Scalars['ID']['input']
}

export type QueryChatMessagesArgs = {
  advancedChatID?: InputMaybe<Scalars['ID']['input']>
  after?: InputMaybe<Scalars['DateTime']['input']>
  before?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<MessageOrder>
  uid: Scalars['ID']['input']
}

export type QueryCheckAppVersionArgs = {
  clientOS: ClientOs
  clientVersion: Scalars['String']['input']
}

export type QueryCoachAvailabilityArgs = {
  containDuplicateStartTime?: InputMaybe<Scalars['Boolean']['input']>
  sourceType?: InputMaybe<Scalars['String']['input']>
}

export type QueryCoachAvailabilityByParticipantArgs = {
  uid: Scalars['ID']['input']
}

export type QueryCoachAvailabilityPublicArgs = {
  containDuplicateStartTime?: InputMaybe<Scalars['Boolean']['input']>
  credentialedHealthplan?: InputMaybe<Scalars['String']['input']>
  stateOfResidence: Scalars['String']['input']
}

export type QueryCoachAvailabilityVideoCallSlotsByParticipantArgs = {
  uid: Scalars['ID']['input']
}

export type QueryCoachProfileArgs = {
  id: Scalars['ID']['input']
}

export type QueryCommunityPostArgs = {
  postID: Scalars['ID']['input']
}

export type QueryCostEstimateLookupArgs = {
  uid: Scalars['ID']['input']
}

export type QueryEmailsArgs = {
  uid: Scalars['ID']['input']
}

export type QueryFeedArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>
  before?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<FeedOrder>
  uid: Scalars['ID']['input']
}

export type QueryHasSpanishTherapistsArgs = {
  credentialingHealthPlan?: InputMaybe<Scalars['String']['input']>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
}

export type QueryInAppSignupFormArgs = {
  input: InAppSignupFormInput
}

export type QueryInAppVideoCallArgs = {
  timezone: Scalars['String']['input']
}

export type QueryIntakeNoteComprehensivePatientDataArgs = {
  uid: Scalars['ID']['input']
}

export type QueryLabOrderArgs = {
  orderID: Scalars['ID']['input']
}

export type QueryLookupPatientByEmailArgs = {
  email: Scalars['EmailAddress']['input']
}

export type QueryPatientArgs = {
  uid: Scalars['ID']['input']
}

export type QueryPatientFileArgs = {
  fileID: Scalars['ID']['input']
}

export type QueryPatientHistoryArgs = {
  orderBy?: InputMaybe<PatientHistoryOrderByInput>
  type?: InputMaybe<PatientHistoryType>
  uid: Scalars['ID']['input']
}

export type QueryPatientHistoryPrefillDataArgs = {
  callID?: InputMaybe<Scalars['ID']['input']>
  type: PatientHistoryType
  uid: Scalars['ID']['input']
}

export type QueryPatientQuestionnaireAssignmentsArgs = {
  uid: Scalars['ID']['input']
}

export type QueryPatientsArgs = {
  uids: Array<Scalars['ID']['input']>
}

export type QueryPrefilledIntakeNoteArgs = {
  uid: Scalars['ID']['input']
}

export type QueryRelevantHistoryArgs = {
  ignoreResponseIDs?: InputMaybe<Array<Scalars['String']['input']>>
  lessonIDs: Array<Scalars['String']['input']>
}

export type QueryResponseArgs = {
  responseID: Scalars['ID']['input']
}

export type QuerySearchPatientsV2Args = {
  coachIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  eligibilityUnconfirmed?: InputMaybe<Scalars['Boolean']['input']>
  includeOnlyPrimaryPatients?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<PatientSortField>
  sortOrder?: InputMaybe<PatientSortOrder>
  sources?: InputMaybe<Array<Scalars['String']['input']>>
  states?: InputMaybe<Array<EnrollmentState>>
  statesOfResidence?: InputMaybe<Array<Scalars['String']['input']>>
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  weeks?: InputMaybe<Array<PatientProgramWeek>>
}

export type QueryTaskRecommendationsArgs = {
  timezone: Scalars['String']['input']
}

export type QueryTaskRecommendationsForPatientArgs = {
  timezone: Scalars['String']['input']
  uid: Scalars['ID']['input']
}

export type QueryVideoCallUrlArgs = {
  id: Scalars['ID']['input']
}

export type QuestionnaireAssignment = {
  __typename?: 'QuestionnaireAssignment'
  assignedAt: Scalars['DateTime']['output']
  assignmentID: Scalars['ID']['output']
  coachID: Scalars['ID']['output']
  completedAt?: Maybe<Scalars['DateTime']['output']>
  dueAt: Scalars['DateTime']['output']
  questionnaire: AssignableQuestionnaire
  repeatCadenceInDays?: Maybe<Scalars['Int']['output']>
  uid: Scalars['ID']['output']
}

export enum ReEnrollmentReason {
  RescheduleCall = 'RESCHEDULE_CALL',
  ResetParticipant = 'RESET_PARTICIPANT',
  RestartParticipant = 'RESTART_PARTICIPANT',
}

export type RelevantHistoryResult = {
  __typename?: 'RelevantHistoryResult'
  responses: Array<PatientResponse>
}

export type RescheduleVideoCallByParticipantResult = OpenScheduleVideoCallLesson

export type ResumedPatientResponse = {
  __typename?: 'ResumedPatientResponse'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  resumedResponse: PatientResponse
}

export type RiskIndicator = {
  __typename?: 'RiskIndicator'
  level: RiskLevel
  /**
   * Movement of the question 9 answer compared with the previous PHQ-9 entry. STABLE when the answer
   * is unchanged or there is no previous entry.
   */
  trend: AssessmentTrend
}

/** The participant's latest PHQ-9 question 9 answer. */
export enum RiskLevel {
  /** Answered 3 — "Nearly every day". */
  High = 'HIGH',
  /** Answered 1 — "Several days". */
  Low = 'LOW',
  /** Answered 2 — "More than half the days". */
  Medium = 'MEDIUM',
}

export type SavePushNotificationTokenResult = {
  __typename?: 'SavePushNotificationTokenResult'
  success: Scalars['Boolean']['output']
}

export type ScheduleVideoCallByCareCoordinatorInput = {
  availabilityCalendarEventID?: InputMaybe<Scalars['String']['input']>
  coachEmail: Scalars['String']['input']
  startTime: Scalars['DateTime']['input']
  timezone: Scalars['String']['input']
}

export type ScheduleVideoCallByExternalManagerInput = {
  availabilityCalendarEventID: Scalars['String']['input']
  coachEmail: Scalars['String']['input']
  startTime: Scalars['DateTime']['input']
  timezone: Scalars['String']['input']
}

export type ScheduleVideoCallByParticipantInput = {
  availabilityCalendarEventID: Scalars['String']['input']
  coachEmail: Scalars['String']['input']
  startTime: Scalars['DateTime']['input']
  timezone: Scalars['String']['input']
}

export type ScheduleVideoCallByParticipantResult = VideoCall | VideoCallSlotTaken

export type ScheduleVideoCallInput = {
  reason: ScheduledVideoCallReason
  startTime: Scalars['DateTime']['input']
  uid: Scalars['ID']['input']
}

export type ScheduleVideoCallResult = {
  __typename?: 'ScheduleVideoCallResult'
  callID: Scalars['ID']['output']
  coachID: Scalars['ID']['output']
  reason: ScheduledVideoCallReason
  scheduledEndTime: Scalars['DateTime']['output']
  scheduledStartTime: Scalars['DateTime']['output']
  uid: Scalars['ID']['output']
  /** @deprecated Migrated to whereby as provider */
  zoomMeetingID: Scalars['String']['output']
}

export enum ScheduledVideoCallReason {
  EngagementIssue = 'ENGAGEMENT_ISSUE',
  EscalatingSymptoms = 'ESCALATING_SYMPTOMS',
  LifeIssue = 'LIFE_ISSUE',
  OtherReason = 'OTHER_REASON',
  PatientInitiated = 'PATIENT_INITIATED',
}

export type SearchPatientsResponse = {
  __typename?: 'SearchPatientsResponse'
  patientCount: Scalars['Int']['output']
  patients: Array<Patient>
}

export type SelfCareReminder = {
  __typename?: 'SelfCareReminder'
  id: Scalars['ID']['output']
  status: SelfCareReminderStatus
  /** Local wall-clock time in 24-hour HH:mm. */
  timeOfDay: Scalars['String']['output']
}

export enum SelfCareReminderStatus {
  /** Push notifications were enabled during the module in which the time was set, so the reminder is sent daily. */
  Active = 'ACTIVE',
  /** Push notifications were not enabled during the module in which the time was set, so the saved time is ignored. */
  Expired = 'EXPIRED',
  /** Set during the current module without push notifications enabled yet; becomes ACTIVE if they are enabled during this module. */
  Pending = 'PENDING',
  /** The participant stopped the reminder. */
  Stopped = 'STOPPED',
}

export type Session = {
  __typename?: 'Session'
  email?: Maybe<Scalars['String']['output']>
  firebaseToken?: Maybe<Scalars['String']['output']>
  isAdmin?: Maybe<Scalars['Boolean']['output']>
  isCareCoordinator?: Maybe<Scalars['Boolean']['output']>
  isCoach?: Maybe<Scalars['Boolean']['output']>
  isCommunityFacilitator?: Maybe<Scalars['Boolean']['output']>
  isExternalManager?: Maybe<Scalars['Boolean']['output']>
  isManager?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  refreshAt?: Maybe<Scalars['BigInt']['output']>
  uid: Scalars['ID']['output']
  validUntil?: Maybe<Scalars['BigInt']['output']>
}

export type SetCareteamAction = {
  __typename?: 'SetCareteamAction'
  coachIDs?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  primaryCoachID?: Maybe<Scalars['ID']['output']>
  uid?: Maybe<Scalars['ID']['output']>
}

export type SetModuleGoalInput = {
  moduleNumber: Scalars['Int']['input']
  practiceGoal: PracticeGoal
}

export type SignupAccountDetails = {
  __typename?: 'SignupAccountDetails'
  activeStates?: Maybe<Array<ActiveState>>
  costOfCharge?: Maybe<Scalars['String']['output']>
  healthPlan?: Maybe<Scalars['String']['output']>
  label: Scalars['String']['output']
  noOfCharge?: Maybe<Scalars['Int']['output']>
  source?: Maybe<Scalars['String']['output']>
  sourceType?: Maybe<Scalars['String']['output']>
  subAccounts?: Maybe<Array<SignupAccountDetails>>
  totalOfCharge?: Maybe<Scalars['String']['output']>
}

export type SignupAccounts = {
  __typename?: 'SignupAccounts'
  healthPlans: Array<SignupAccountDetails>
  organizations: Array<SignupAccountDetails>
}

export type SignupForm = {
  __typename?: 'SignupForm'
  screens: Array<SignupFormScreen>
}

export type SignupFormConsentDocument = {
  __typename?: 'SignupFormConsentDocument'
  id: Scalars['String']['output']
  path: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type SignupFormConsentItem = {
  __typename?: 'SignupFormConsentItem'
  documents: Array<SignupFormConsentDocument>
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
}

export type SignupFormConsents = {
  __typename?: 'SignupFormConsents'
  fieldName: SignupFormFieldName
  items: Array<SignupFormConsentItem>
}

export type SignupFormCustomQuestion = {
  __typename?: 'SignupFormCustomQuestion'
  question: Scalars['String']['output']
  questionID: Scalars['String']['output']
}

export type SignupFormDateSelector = {
  __typename?: 'SignupFormDateSelector'
  annotation?: Maybe<Scalars['String']['output']>
  fieldName: SignupFormFieldName
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  validation?: Maybe<SignupFormDateSelectorValidation>
}

export type SignupFormDateSelectorValidation = {
  __typename?: 'SignupFormDateSelectorValidation'
  minimumYears?: Maybe<Scalars['Int']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
}

export type SignupFormEmailInput = {
  __typename?: 'SignupFormEmailInput'
  annotation?: Maybe<Scalars['String']['output']>
  fieldName: SignupFormFieldName
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  validation?: Maybe<SignupFormEmailInputValidation>
}

export type SignupFormEmailInputValidation = {
  __typename?: 'SignupFormEmailInputValidation'
  required?: Maybe<Scalars['Boolean']['output']>
}

export enum SignupFormFieldName {
  AcceptedConsents = 'ACCEPTED_CONSENTS',
  CustomQuestion = 'CUSTOM_QUESTION',
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  Employer = 'EMPLOYER',
  FirstName = 'FIRST_NAME',
  InsuranceGroupId = 'INSURANCE_GROUP_ID',
  InsuranceMemberId = 'INSURANCE_MEMBER_ID',
  InsuranceSubscriberOfDependentDateOfBirth = 'INSURANCE_SUBSCRIBER_OF_DEPENDENT_DATE_OF_BIRTH',
  InsuranceSubscriberOfDependentFirstName = 'INSURANCE_SUBSCRIBER_OF_DEPENDENT_FIRST_NAME',
  InsuranceSubscriberOfDependentLastName = 'INSURANCE_SUBSCRIBER_OF_DEPENDENT_LAST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  ReferralName = 'REFERRAL_NAME',
  StateOfResidence = 'STATE_OF_RESIDENCE',
}

export type SignupFormInput =
  | SignupFormConsents
  | SignupFormDateSelector
  | SignupFormEmailInput
  | SignupFormItemSelector
  | SignupFormPhoneNumberInput
  | SignupFormTextInput

export type SignupFormIsDependentScreen = {
  __typename?: 'SignupFormIsDependentScreen'
  id: Scalars['ID']['output']
  nextScreenForDependent: Scalars['String']['output']
  nextScreenForNonDependent: Scalars['String']['output']
  selector: SignupFormIsDependentSelector
  title?: Maybe<Scalars['String']['output']>
  titleAnnotation?: Maybe<Scalars['String']['output']>
}

export type SignupFormIsDependentSelector = {
  __typename?: 'SignupFormIsDependentSelector'
  items: Array<SignupFormIsDependentSelectorItem>
}

export type SignupFormIsDependentSelectorItem = {
  __typename?: 'SignupFormIsDependentSelectorItem'
  label: Scalars['String']['output']
  value: Scalars['Boolean']['output']
}

export type SignupFormItemSelector = {
  __typename?: 'SignupFormItemSelector'
  annotation?: Maybe<Scalars['String']['output']>
  customQuestion?: Maybe<SignupFormCustomQuestion>
  fieldName: SignupFormFieldName
  items: Array<SignupFormItemSelectorItem>
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  validation?: Maybe<SignupFormItemSelectorValidation>
}

export type SignupFormItemSelectorItem = {
  __typename?: 'SignupFormItemSelectorItem'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type SignupFormItemSelectorValidation = {
  __typename?: 'SignupFormItemSelectorValidation'
  required?: Maybe<Scalars['Boolean']['output']>
}

export enum SignupFormPhoneNumberFormat {
  Us = 'US',
}

export type SignupFormPhoneNumberInput = {
  __typename?: 'SignupFormPhoneNumberInput'
  annotation?: Maybe<Scalars['String']['output']>
  fieldName: SignupFormFieldName
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  validation?: Maybe<SignupFormPhoneNumberInputValidation>
}

export type SignupFormPhoneNumberInputValidation = {
  __typename?: 'SignupFormPhoneNumberInputValidation'
  format?: Maybe<SignupFormPhoneNumberFormat>
  required?: Maybe<Scalars['Boolean']['output']>
}

export type SignupFormRegularScreen = {
  __typename?: 'SignupFormRegularScreen'
  disclaimer?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  inputs: Array<SignupFormInput>
  title?: Maybe<Scalars['String']['output']>
  titleAnnotation?: Maybe<Scalars['String']['output']>
}

export type SignupFormScreen = SignupFormIsDependentScreen | SignupFormRegularScreen

export type SignupFormTextInput = {
  __typename?: 'SignupFormTextInput'
  annotation?: Maybe<Scalars['String']['output']>
  customQuestion?: Maybe<SignupFormCustomQuestion>
  fieldName: SignupFormFieldName
  label?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  validation?: Maybe<SignupFormTextInputValidation>
}

export type SignupFormTextInputValidation = {
  __typename?: 'SignupFormTextInputValidation'
  required?: Maybe<Scalars['Boolean']['output']>
}

export type SmsMessage = {
  __typename?: 'SmsMessage'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  direction: SmsMessageDirection
  status: SmsMessageStatus
  text: Scalars['String']['output']
  twilioMessageID: Scalars['ID']['output']
  uid: Scalars['ID']['output']
}

export enum SmsMessageDirection {
  ToCoach = 'TO_COACH',
  ToPatient = 'TO_PATIENT',
}

export enum SmsMessageStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Received = 'RECEIVED',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT',
  Undelivered = 'UNDELIVERED',
}

export type Source = {
  __typename?: 'Source'
  disableInExternalDashboard?: Maybe<Scalars['Boolean']['output']>
  externalManagerAllowedStates?: Maybe<Array<Scalars['String']['output']>>
  healthPlan?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  onboardingTitle?: Maybe<Scalars['String']['output']>
  sourceType?: Maybe<Scalars['String']['output']>
}

export type StoreMeditationDurationResult = {
  __typename?: 'StoreMeditationDurationResult'
  response?: Maybe<PatientResponse>
}

export type StorePatientResponseResult = {
  __typename?: 'StorePatientResponseResult'
  response?: Maybe<PatientResponse>
}

export type StorePaymentMethodCloseAction = {
  __typename?: 'StorePaymentMethodCloseAction'
  copy: Scalars['String']['output']
}

export type StorePaymentMethodInput = {
  stripeCard?: InputMaybe<StripeCardInput>
}

export type StorePaymentMethodResult = StorePaymentMethodResultSuccess

export type StorePaymentMethodResultSuccess = {
  __typename?: 'StorePaymentMethodResultSuccess'
  closeAction?: Maybe<StorePaymentMethodCloseAction>
  copy?: Maybe<Scalars['String']['output']>
  photoUrl?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type StripeCardInput = {
  cardToken: Scalars['String']['input']
}

export type TaskRecommendation = {
  __typename?: 'TaskRecommendation'
  banner?: Maybe<TaskRecommendationBanner>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  icon?: Maybe<Scalars['String']['output']>
  isDisabled: Scalars['Boolean']['output']
  lessonID: Scalars['ID']['output']
  response?: Maybe<PatientResponse>
  taskID: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type TaskRecommendationBanner = {
  __typename?: 'TaskRecommendationBanner'
  label: Scalars['String']['output']
}

export type TaskRecommendationsResult = {
  __typename?: 'TaskRecommendationsResult'
  taskRecommendations: Array<TaskRecommendation>
}

export type TimelineLesson = {
  __typename?: 'TimelineLesson'
  category: LessonCategory
  duration: Scalars['Int']['output']
  id: Scalars['ID']['output']
  isDisabled: Scalars['Boolean']['output']
  response?: Maybe<PatientResponse>
  showDetails: Scalars['Boolean']['output']
  taskID?: Maybe<Scalars['ID']['output']>
  title: Scalars['String']['output']
}

export type TimelineWeek = {
  __typename?: 'TimelineWeek'
  endDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  illustrations: Array<Illustration>
  isCurrentWeek: Scalars['Boolean']['output']
  lessons: Array<TimelineLesson>
  startDate: Scalars['String']['output']
  /** @deprecated Use Program.weeks { title } for localized week titles */
  title: Scalars['String']['output']
}

export type TrackAppOpenResult = {
  __typename?: 'TrackAppOpenResult'
  success: Scalars['Boolean']['output']
}

export type TrackAppUsageSessionsResult = {
  __typename?: 'TrackAppUsageSessionsResult'
  savedCount: Scalars['Int']['output']
  success: Scalars['Boolean']['output']
}

export type TrackPushNotificationOpenResult = {
  __typename?: 'TrackPushNotificationOpenResult'
  success: Scalars['Boolean']['output']
}

export type TrackPushNotificationPermissionStatusResult = {
  __typename?: 'TrackPushNotificationPermissionStatusResult'
  success: Scalars['Boolean']['output']
}

export type UnseenChatMessages = {
  __typename?: 'UnseenChatMessages'
  unseenMessagesCount: Scalars['Int']['output']
}

export type UpcomingPayment = {
  __typename?: 'UpcomingPayment'
  amountCopy?: Maybe<Scalars['String']['output']>
  badgeCopy?: Maybe<Scalars['String']['output']>
  dueDateCopy?: Maybe<Scalars['String']['output']>
  paymentStatus?: Maybe<UpcomingPaymentStatus>
  weekRangeCopy?: Maybe<Scalars['String']['output']>
}

export enum UpcomingPaymentStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
}

/** A scheduled program start that is still ahead. */
export type UpcomingProgram = {
  __typename?: 'UpcomingProgram'
  /** The start day's lessons, all disabled until the program starts. */
  lessons: Array<TaskRecommendation>
  startDate: Scalars['Date']['output']
  /** 'Starts today', 'Starts tomorrow' or 'Starts on <date>', by calendar day in the patient's timezone. */
  title: Scalars['String']['output']
}

export type UpdateOnboardingPatientInput = {
  birthDate: Scalars['String']['input']
  firstname: Scalars['String']['input']
  groupID?: InputMaybe<Scalars['String']['input']>
  insuranceSubscriberOfDependent?: InputMaybe<InsuranceSubscriberOfDependentInput>
  lastname?: InputMaybe<Scalars['String']['input']>
  memberID?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
}

export type UpdatePatientFileInput = {
  filename: Scalars['String']['input']
}

export type UpdateSourceAndStateOfResidenceInput = {
  /** Onboarding UI language. Stored as the app language when the plan is in the Spanish rollout, English otherwise. */
  language?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
}

export type VideoCall = {
  __typename?: 'VideoCall'
  activeDurationInMS?: Maybe<Scalars['Int']['output']>
  callException?: Maybe<VideoCallException>
  callType: VideoCallType
  cancelledAt?: Maybe<Scalars['DateTime']['output']>
  cancelledBy?: Maybe<VideoCallCancelledBy>
  checkInCallPatientHistoryEntryID?: Maybe<Scalars['ID']['output']>
  coach: CoachProfile
  createdAt: Scalars['DateTime']['output']
  endTime: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  joinUrl?: Maybe<Scalars['String']['output']>
  meetingID?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  numberOfParticipants?: Maybe<Scalars['Int']['output']>
  reason?: Maybe<ScheduledVideoCallReason>
  startTime: Scalars['DateTime']['output']
  /** @deprecated Use meetingID instead */
  zoomMeetingID: Scalars['String']['output']
}

export type VideoCallBookingInformation = InProgramVideoCallBookingInformation | IntakeVideoCallBookingInformation

export enum VideoCallCancelledBy {
  Coach = 'COACH',
  Participant = 'PARTICIPANT',
}

export enum VideoCallException {
  LateCancellation = 'LATE_CANCELLATION',
  NoShow = 'NO_SHOW',
  OtherException = 'OTHER_EXCEPTION',
  ProviderIssue = 'PROVIDER_ISSUE',
}

export type VideoCallPatientHistory = PatientHistory & {
  __typename?: 'VideoCallPatientHistory'
  coachID?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['DateTime']['output']
  date?: Maybe<Scalars['String']['output']>
  entryID: Scalars['ID']['output']
  files?: Maybe<Array<PatientFile>>
  source?: Maybe<Scalars['String']['output']>
  type?: Maybe<PatientHistoryType>
  value?: Maybe<Scalars['JSONObject']['output']>
  videoCall: VideoCall
}

export type VideoCallSlot = {
  __typename?: 'VideoCallSlot'
  availabilityCalendarEventID: Scalars['String']['output']
  coachEmail: Scalars['String']['output']
  end: Scalars['DateTime']['output']
  start: Scalars['DateTime']['output']
}

export type VideoCallSlotTaken = {
  __typename?: 'VideoCallSlotTaken'
  availabilityCalendarEventID: Scalars['String']['output']
  callType?: Maybe<VideoCallType>
  startTime: Scalars['DateTime']['output']
}

export enum VideoCallType {
  Intake = 'INTAKE',
  InProgram = 'IN_PROGRAM',
}

export type WeekTheme = {
  __typename?: 'WeekTheme'
  id: Scalars['ID']['output']
  lessons: Array<Lesson>
  title: Scalars['String']['output']
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY',
}
